<template>
  <div id="overview">
    <modalWindow
      width="400" v-if="firstPassword && showPassword"
      @close="showPassword=!showPassword"
    >
      <div class="titlebar">Wachtwoord instellen</div>
      <div v-if="msg" class="form-notice">
        <awesomeIcon icon="exclamation-circle" /> {{msg}}
      </div>
      <form @submit.prevent class="inset">
        <input type=password ref="newpassword" placeholder="Nieuwe wachtwoord">
        <input type=password ref="newpassword2" placeholder="Nogmaals nieuwe wachtwoord">
        <input type=submit @click="resetPassword" value="Wachtwoord instellen">
      </form>
    </modalWindow>
    <div
      v-if="errors != 0 || $parent.role == -1"
      class="msg error"
    >
      <div v-if="filter(modelValue.persoonsData, (o) => {o.usperson === 'Yes'}).length">
        U kunt de vragenlijst niet indienen omdat u aangeeft een US-person te zijn.
      </div>
      <div v-else-if="$parent.redo">
        U kunt uw klantprofiel nog niet opslaan. U dient nog
        <b>{{ errors }}</b> vragen te beantwoorden.
      </div>
      <div v-else-if="errors != 0">
        U kunt de vragenlijst nog niet indienen, er {{ errors > 1 ? 'zijn' : 'is' }} nog
        <b>{{ errors }}</b> {{ errors > 1 ? 'ontbrekende velden' : 'ontbrekend veld' }}.
      </div>
      <div v-if="$parent.role == -1 && !firstPassword">
        Ook is uw e-mailadres nog niet bevestigd. U heeft hierover een e-mailbericht gehad.
      </div>
      <div v-else-if="$parent.role == -1">
        U dient uw wachtwoord in te stellen om de vragenlijst in te dienen.
        <button class="alertButton" @click="showPassword=true">Stel uw wachtwoord in</button>
      </div>
    </div>
    <div v-if="errors == 0 && !$parent.redo" class="msg">
      <b>Klaar! Nog een paar laatste puntjes</b><br />
      Nog een laatste check voordat we uw rekening aanvragen. Hieronder kunt u
      zien of u wellicht nog wat bent vergeten en nakijken wat u heeft
      ingevuld. Wijzig gerust nog iets als u dat wilt.<br /><br />
      Bent u tevreden en wilt u uw gegevens opslaan? klik op <b>Rekening aanvragen</b>
      onderaan deze pagina.
      <div v-if="invalidCollect || invalidTerms || invalidAtp">
        Om de vragenlijst in te dienen, dient u akkoord te gaan met de voorwaarden. Deze vindt u
        terug onderaan deze pagina.
      </div>
    </div>
    <div
      v-else-if="errors == 0 && invalidCollect"
      :class="['msg', 'printhide', 'icon', 'error']"
    >
      <div class="icon">
        <awesomeIcon icon="ban"/>
      </div>
      <div class="alertText">
        <b>U kunt uw klantprofiel niet versturen</b>
        <br />U dient onder op deze pagina de machtiging voor automatisch incasso te accepteren.
      </div>
    </div>
    <div
      v-else-if="errors == 0 && $parent.redo"
      :class="['msg', 'printhide', 'icon', 'valid']"
    >
      <div class="icon">
        <awesomeIcon icon="check"/>
      </div>
      <div class="alertText">
        <b>U kunt uw klantprofiel versturen</b>
        <br />Controleer goed of de wijzigingen in uw situatie juist zijn ingevoerd en
        stuur ze op. Daarna gaan wij aan de slag om uw wijzigingen te verwerken.
        U kunt uw wijzigingen na verwerken terugzien in het beleggingsplan.
      </div>
      <button
        @click="$parent.role >= 0 ? $parent.sendIntake() : showPassword = !showPassword"
        class="alertButton"
      >
        Versturen
      </button>
    </div>

    <!-- Doel gegevens -->
    <div class="card row inset">
      <div class="sm-col-12 lg-colnm-12">
        <h2 class="title">
          <awesomeIcon icon="clipboard-list" />
          {{ modelValue.goalData.type == "Geen"
            ? "Algemene Vermogensopbouw"
            : typeToGoal.replace(/^\w/, (c) => c.toUpperCase()) }}
        </h2>
        <button
          class="secondary setting"
          @click="$parent.overviewToggle = false"
          v-if="$parent.status != 'Bezig' && $parent.role > 7"
        >
          <awesomeIcon icon="sign-out-alt" /> Terug naar status (admin)
        </button>
        <button
          class="secondary setting"
          @click="$parent.sendIntake"
          v-if="errors && $parent.status == 'Bezig' && $parent.role > 7"
        >
          <awesomeIcon icon="chevron-right" /> Toch indienen (admin)
        </button>
      </div>

      <div
        :class="[
          'sm-col-12',
          $parent.intakeAdmin.beleggen.brand == 'Doelbeleggen'
            ? 'lg-colnm-6'
            : '',
        ]"
      >
        <div class="edit" @click="modelValue.step = 1">
          <b>Doel <awesomeIcon icon="edit" /></b><br />
          <!-- uitkerende lijfrente info -->
          <template
            v-if="
              (modelValue.goalData.type == 'levensonderhoud' && modelValue.goalData.box == '1')
              || modelValue.goalData.type == 'gouden-handdruk-uitkerend'
              || modelValue.goalData.type == 'netto-lijfrente-uitkerend'
            "
          >
            <template v-if="offerSelected && $parent.intakeAdmin.offers[offerSelected.offerId]">
              U start met
              <check
                :val="offerSelected.vermogen"
                fallback="geen startbedrag"
                type="money"
              />
              <template v-if="!offerSelected.doelAanvulling">
                met een looptijd van
                <check
                  :val="modelValue.goalData.looptijd"
                  fallback="geen looptijd"
                  type="year"
                />
              </template>.<br>
              <template v-if="offerSelected.offerType != '2' && offerSelected.offerType != '3'">
                Het U-rendement is
                {{ $parent.intakeAdmin.offers[offerSelected.offerId].urendement }}.<br>
              </template>
              Netto voorbeeldrendement
              {{ $parent.intakeAdmin.offers[offerSelected.offerId].profile }}%.<br>
              Uitkering eerste jaar &euro;
              {{ formatPrice(Number(
              offerSelected.offerType == 1 || offerSelected.offerType == 4
              ? $parent.intakeAdmin.offers[offerSelected.offerId].calculation.charts.chart2[0][2]
              : offerSelected.offerType != 0 && offerSelected.offerType != 5
                ? $parent.intakeAdmin.offers[offerSelected.offerId].calculation.charts.chart1[0][2]
                : $parent.intakeAdmin.offers[offerSelected.offerId].calculation.charts.chart2[0][1]
              ), true) }},-.
              <template v-if="offerSelected.offerType == '3'">
                Indicatieve looptijd
                {{ formatPrice(Number($parent.intakeAdmin.offers[
                  offerSelected.offerId
                ].calculation.looptijd.huidigprofiel), true) }}
                jaar
              </template>
            </template>
            <check
              v-else-if="!$parent.redo"
              :val="offerSelected"
              fallback="Geen indicatie geselecteerd."
            />
            <div v-else>
              Uw uitkering is gestart.
            </div>
          </template>
          <template v-else-if="!$parent.redo">
            U start met
            <check
              :val="modelValue.goalData.vermogen"
              fallback="geen startbedrag"
              type="money"
            />
            met
            <template v-if="modelValue.goalData.type != 'levensonderhoud'">
              als doel
              <check
                :val="modelValue.goalData.doel"
                fallback="geen doelbedrag"
                type="money"
              />
              in
            </template>
            een looptijd
            <template v-if="!modelValue.goalData.targetDate">
              van
              <check
                :val="modelValue.goalData.looptijd && Number(modelValue.goalData.looptijd) > 0"
                :validtext="`${modelValue.goalData.looptijd} jaar`"
                fallback="geen of negatieve looptijd."
              />
            </template>
            <template v-else>
              tot
              {{ new Date(modelValue.goalData.targetDate).toLocaleDateString() }}
            </template>
            <template v-if="modelValue.goalData.type != 'levensonderhoud'">
              te realiseren.
            </template>
          </template>

          <!-- redo goal info -->
          <template v-else>
            De huidige waarde van de portefeuille is &euro;
            {{ formatPrice($parent.portValue, true) }},-.<br />
            <template v-if="modelValue.goalData.vermogen > 0">
              U gaat eenmalig &euro;
              {{ formatPrice(Number(modelValue.goalData.vermogen), true) }},-
              bijstorten.<br />
            </template>
            <template v-if="modelValue.goalData.type !== 'levensonderhoud'">
              Uw doel is
              <check
                :val="modelValue.goalData.doel"
                fallback="geen vermogensbedrag"
                type="money"
              />
              met nog een looptijd tot
              {{ new Date(modelValue.goalData.targetDate).toLocaleDateString() }}
            </template>
            <template v-else>U wilt onttrekken totaal
              {{ new Date(modelValue.goalData.targetDate).toLocaleDateString() }}
            </template>.
            <check
              v-if="!(new Date(modelValue.goalData.targetDate) >= new Date())"
              :val="new Date(modelValue.goalData.targetDate) >= new Date()"
              :fallback="`Uw doeldatum
                (${new Date(modelValue.goalData.targetDate).toLocaleDateString()})
                ligt in het verleden.`"
              style="display: block"
            />
          </template>

          <!-- extra goal info -->
          <template
            v-if="
              modelValue.goalData.type != 'levensonderhoud'
              && modelValue.goalData.type != 'gouden-handdruk-uitkerend'
              && modelValue.goalData.type != 'netto-lijfrente-uitkerend'
            "
          >
            <template v-if="($parent.intakeAdmin.beleggen.brand == 'VMVB'
                || $parent.intakeAdmin.beleggen.brand == 'BVS')
                && !modelValue.goalData.onttrekkingen">
              <br />
              <check
                :val="modelValue.goalData.onttrekkingen"
                fallback="U heeft nog niet aangegeven of u periodieke onttrekkingen gaat doen."
              />
            </template>
            <template v-if="modelValue.goalData.stortingen == 'Yes'">
              <check
                :val="modelValue.goalData.stortingenInterval"
                fallback="Periode ontbreekt"
              />
              stort u
              <check
                :val="modelValue.goalData.stortingenBedrag"
                fallback="stortingsbedrag" type="money"
              />
              bij.
            </template>
            <template v-else-if="modelValue.goalData.type !== 'gouden-handdruk-opbouwend'">
              U gaat periodiek niets storten
            </template>
            <template v-if="
              modelValue.goalData.onttrekkingen == 'Yes'
              && Number(modelValue.goalData.onttrekkingenBedrag) > 0
            ">
              En u gaat
              <check
                :val="modelValue.goalData.onttrekkingenBedrag"
                fallback="ontrekkingsbedrag"
                type="money"
              />
              <check
                :val="modelValue.goalData.onttrekkingenInterval"
                fallback="Periode ontbreekt"
              />
              onttrekken
              <template v-if="modelValue.goalData.onttrekkingenStart > 0">
                (eerste ontrekking over
                {{ modelValue.goalData.onttrekkingenStart }} jaar)
              </template>.
            </template>
            <template
              v-else-if="
                ($parent.intakeAdmin.beleggen.brand == 'VMVB'
                || $parent.intakeAdmin.beleggen.brand == 'BVS')
                && modelValue.goalData.onttrekkingen == 'No'
              "
            >
              en u gaat geen geld opnemen
            </template>
          </template>
          <template
            v-if="
              modelValue.goalData.type == 'levensonderhoud'
              && modelValue.goalData.box !== '1'
              && $parent.intakeAdmin.beleggen.brand == 'Doelbeleggen'
            "
          >
            <br />U gaat {{ modelValue.goalData.stortingenInterval.toLowerCase() }} &euro;
            {{
              formatPrice(
                Number(modelValue.goalData.doelAanvulling || 0),
                true
              )
            }},- onttrekken (&euro;
            {{
              formatPrice(
                Number(modelValue.goalData.doelAanvulling || 0) * paymentTerms,
                true
              )
            }},- per jaar).
          </template>
          <template
            v-if="
              modelValue.goalData.type == 'levensonderhoud' &&
              ($parent.intakeAdmin.beleggen.brand == 'VMVB' ||
                $parent.intakeAdmin.beleggen.brand == 'BVS')
              && modelValue.goalData.onttrekkingen === 'Yes'
            "
          >
            <br />U gaat
            <check
              :val="modelValue.goalData.onttrekkingenBedrag"
              fallback="ontrekkingsbedrag"
              type="money"
            />
            <check
              :val="modelValue.goalData.onttrekkingenInterval"
              fallback="periode"
              style="text-transform: lowercase"
            />
            onttrekken (eerste ontrekking over
            <check
              :val="modelValue.goalData.onttrekkingenStart"
              fallback="periode"
              type="number"
            />
            jaar).
          </template>
        </div>
        <div class="edit" @click="modelValue.step = 8">
          <br><b>Risico <awesomeIcon icon="edit" /></b><br>
          U bent bereid
          <check :val="modelValue.goalData.risk" fallback="geen waarde" />
          risico te lopen
          <template
            v-if="
              $parent.intakeAdmin.beleggen.brand == 'Doelbeleggen' &&
              modelValue.goalData.risk != 'geen' &&
              modelValue.goalData.risk != undefined
            "
          >
            ({{
              $parent.fromSatProfile($parent.toSatProfile(modelValue.goalData.risk))
            }})
          </template>
          als het gaat om jaarlijkse waardeschommelingen.
          <template v-if="
            $parent.fromSatProfile(modelValue.goalData.optimalProfile) !== 'Doelbeleggen Sparen'
          ">
            <br />Profiel {{$parent.fromSatProfile(modelValue.goalData.optimalProfile)}} is bij uw
            gegevens optimaal, over het algemeen wordt uw portefeuille in lijn met dit profiel
            ingericht.
          </template>
          <br />
          <check
            v-if="!modelValue.goalData.confirmRisk"
            :val="modelValue.goalData.confirmRisk"
            fallback="Doelstelling risico vraag niet beantwoord."
          />
          <br v-if="!modelValue.goalData.confirmRisk" />
          <check
            v-if="!modelValue.goalData.confirmRiskLoss"
            :val="modelValue.goalData.confirmRiskLoss"
            fallback="Inleg verlies vraag niet beantwoord."
          />
          <br v-if="!modelValue.goalData.confirmRiskLoss" />
          <!-- If the user has box 1 (leefrente)-->
          <check
            v-if="modelValue.goalData.type === 'levensonderhoud'
              && modelValue.goalData.box === '1'
              && (modelValue.goalData.risk === 'hoog'
                || modelValue.goalData.risk === 'zeer hoog'
                || modelValue.goalData.risk === 'extreem hoog')
              && !modelValue.goalData.confirmRiskPension"
            :val="modelValue.goalData.confirmRiskPension"
            fallback="Acceptatie waardeschommeling vraag niet beantwoord."
          />
          <br
            v-if="modelValue.goalData.type === 'levensonderhoud'
              && modelValue.goalData.box === '1'
              && (modelValue.goalData.risk === 'hoog'
                || modelValue.goalData.risk === 'zeer hoog'
                || modelValue.goalData.risk === 'extreem hoog')
              && !modelValue.goalData.confirmRiskPension"
          />
          <template
            v-if="
              $parent.intakeAdmin.beleggen.brand == 'VMVB' ||
              $parent.intakeAdmin.beleggen.brand == 'BVS'
            "
          >
            U vermijdt
            <check :val="modelValue.goalData.risk2" fallback="geen waarde" />
            risico's die een hoger rendement kunnen realiseren.
            <template
              v-if="
                modelValue.goalData.confirmRisk2 == 'No' &&
                (modelValue.goalData.risk2 == 'alle' ||
                  modelValue.goalData.risk2 == 'zo veel mogelijk')
              "
              >Maar u accepteert geen lager rendement.</template
            >
            <template
              v-if="
                modelValue.goalData.confirmRisk3 == 'No' &&
                (modelValue.goalData.risk2 == 'bijna geen' ||
                  modelValue.goalData.risk2 == 'geen')
              "
              >Maar u accepteert niet de potentiele verliezen.</template
            >
            <br />U maakt zich
            <check :val="modelValue.goalData.risk3" fallback="geen waarde" />
            zorgen over verliezen uit het verleden. <br />U raadpleegt
            <check :val="modelValue.goalData.risk5" fallback="geen waarde" />
            uw portefeuille. <br />U komt in
            <check :val="modelValue.goalData.risk4" fallback="geen waarde" />
            problemen wanneer uw doelstelling niet wordt gehaald. <br />Wij
            informeren u rond een contactwaarde van &euro;
            {{
              formatPrice(
                ((Number(modelValue.goalData.vermogen) +
                  Number($parent.portValue)) /
                  100) *
                  Number(modelValue.goalData.warning),
                true
              )
            }},-. U heeft een probleemwaarde van &euro;
            {{
              formatPrice(
                ((Number(modelValue.goalData.vermogen) +
                  Number($parent.portValue)) /
                  100) *
                  Number(modelValue.goalData.stepout),
                true
              )
            }},- opgegeven. Deze waarden worden gecorrigeerd op stortingen en
            onttrekkingen.
          </template>
          <template v-else-if="Number(modelValue.goalData.warning) == 0">
            Wij informeren u niet over uw haalbaarheid.
          </template>
          <template v-else>
            Wij informeren u wanneer de haalbaarheid zakt onder de
            <check
              v-if="modelValue.goalData.warning == null"
              :val="modelValue.goalData.warning"
              fallback="geen waarde."
              type="number"
            />
            <template v-else>
              {{ Number(modelValue.goalData.warning) }}%.
            </template>
          </template>
          <br/>
          <check
            v-if="!modelValue.goalData.lifecycleCustomer"
            fallback="Lifecycle vraag nog niet beantwoord"
            :val="modelValue.goalData.lifecycleCustomer"
          />
          <check
            v-if="modelValue.goalData.lifecycleCustomer === 'Yes'"
            validtext="Lifecycle is geactiveerd"
            :val="modelValue.goalData.lifecycleCustomer"
          />
          <check
            v-if="modelValue.goalData.lifecycleCustomer === 'No'
              && !modelValue.goalData.lifecycleCustomerOff"
            fallback="Lifecycle uitschakelen vraag nog niet beantwoord"
          />
          <check
            v-if="modelValue.goalData.lifecycleCustomer === 'No'
              && modelValue.goalData.lifecycleCustomerOff"
            fallback="Lifecycle uitschakelen vraag nog niet beantwoord"
            :validtext="'Lifecycle uit vanwege: ' + `${modelValue.goalData.lifecycleCustomerOff}`"
            :val="modelValue.goalData.lifecycleCustomerOff"
          />
          <!-- Afgelopen periode ervaren -->
          <template v-if="$parent.redo">
            <br />
            <check
              :val="modelValue.goalData.pastPeriodExperience"
              :validtext="pastPeriodChoice"
              fallback="U heeft de schommelingenvraag nog niet beantwoord."
            />
          </template>
        </div>
      </div>
      <div
        v-if="$parent.intakeAdmin.beleggen.brand == 'Doelbeleggen'"
        class="sm-col-12 lg-colnm-6 edit"
        style="overflow: hidden"
        @click="modelValue.step = 1"
      >
        <div style="max-width: 250px; margin: 0 auto;">
          <scorewidget
            v-model="modelValue.goalData.score"
            :showNotice="false"
          />
        </div>
      </div>
    </div>

    <!-- Bedrijfs gegevens -->
    <div
      class="card inset"
      v-if="modelValue.rekeningData.type == 'Bedrijfsrekening'"
    >
      <div class="row">
        <div class="edit sm-col-12 lg-colnm-6" @click="modelValue.step = 3">
          <b>
            <check :val="`${modelValue.bedrijfsData.bedrijfsnaam} `" fallback="Bedrijfsnaam " />
            <awesomeIcon icon="edit" />
          </b><br />
          <check :val="modelValue.bedrijfsData.straat" fallback="Straat" />
          <check
            :val="modelValue.bedrijfsData.huisnummer"
            fallback="huisnummer"
          />
          {{ modelValue.bedrijfsData.toevoeging }} -
          <check :val="modelValue.bedrijfsData.postcode" fallback="postcode" />
          <check :val="modelValue.bedrijfsData.plaats" fallback="plaats" />
          <check :val="modelValue.bedrijfsData.land" fallback="land" /><br />
          Rechtsvorm
          <check
            :val="modelValue.bedrijfsData.rechtsvorm === 'anders'
            ? modelValue.bedrijfsData.rechtsvormAnders
            : modelValue.bedrijfsData.rechtsvorm" fallback="rechtsvorm"
          />
          KVK
          <check :val="modelValue.bedrijfsData.kvk" fallback="KVK-nummer" /><br />
          <template v-if="modelValue.bedrijfsData.lei">
            LEI-nummer
            <check :val="modelValue.bedrijfsData.lei" fallback="LEI-nummer" /><br/>
          </template>
          <template v-else>
            Nog niet in het bezit van een LEI-nummer<br/>
          </template>
          <template v-if="modelValue.bedrijfsData.rsin">
            RSIN-nummer
            <check :val="modelValue.bedrijfsData.rsin" fallback="RSIN-nummer" /><br/>
          </template>
          <template v-else>
            Nog niet in het bezit van een RSIN-nummer<br/>
          </template>
        </div>
        <div
          class="edit sm-col-12 lg-colnm-6"
          @click="
            modelValue.financeData.step = null;
            modelValue.step = 5;
          "
        >
          <b>Financiële situatie <awesomeIcon icon="edit" /></b><br />
          <check
            v-if="!modelValue.financeData.negatiefVermorgen"
            :val="modelValue.financeData.negatiefVermorgen"
            fallback="Negatief eigen vermogen vraag nog niet beantwoord."
          />
          <template v-else-if="modelValue.financeData.negatiefVermorgen == 'Yes'"
            >Heeft negatief eigen vermogen.</template
          >
          <template v-else>Geen negatief eigen vermogen.</template><br />
          <check
            v-if="!modelValue.financeData.uitgeleend"
            :val="modelValue.financeData.uitgeleend"
            fallback="Geld uitgeleend aan prive personen nog niet beantwoord."
          />
          <template v-else-if="modelValue.financeData.uitgeleend == 'Yes'">
            <check
              v-if="!modelValue.financeData.uitgeleendU"
              :val="modelValue.financeData.uitgeleendU"
              fallback="Geld uitgeleend aan U nog niet beantwoord."
            />
            <template v-else-if="modelValue.financeData.uitgeleendU == 'Yes'"
              >Geld uitgeleend aan U.</template
            >
            <template v-else
              >Geld uitgeleend aan prive personen maar niet aan U.</template
            >
          </template>
          <template v-else>Geen geld uitgeleend aan prive personen.</template
          ><br />
          <check
            v-if="
              ['bv', 'stichting', 'nv', 'anders'].includes(modelValue.bedrijfsData.rechtsvorm)
              && !modelValue.financeData.jaarrekening
            "
            :val="modelValue.financeData.jaarrekening"
            fallback="Jaarrekening vraag niet beantwoord."
            style="display: block"
          />
          <check
            v-if="
              ['bv', 'stichting', 'nv', 'anders'].includes(modelValue.bedrijfsData.rechtsvorm)
              && modelValue.financeData.jaarrekening == 'Yes'
            "
            :val="filesFilter(`-jaarrekening-`)"
            fallback="Jaarrekening bestand niet opgegeven."
            validtext="Jaarrekening opgegeven."
            style="display: block"
          />
          <check
            v-if="!modelValue.financeData.statutenInvest"
            :val="modelValue.financeData.statutenInvest"
            fallback="Statuten vermogen beleggen vraag niet beantwoord"
          />
          <check
            v-if="!modelValue.financeData.statuten"
            :val="modelValue.financeData.statuten"
            fallback="Statuten vraag niet beantwoord."
            style="display: block"
          />
          <check
            v-if="modelValue.financeData.statuten == 'Yes'"
            :val="filesFilter(`-statuten-`)"
            fallback="Statuten bestand niet opgegeven."
            validtext="Statuten opgegeven."
            style="display: block"
          />
        </div>
      </div>

      <div class="row">
        <!-- Bezittingen -->
        <div
          v-if="
            modelValue.rekeningData.type === 'Bedrijfsrekening'
            && (
              $parent.intakeAdmin.beleggen.brand === 'VMVB'
              || $parent.intakeAdmin.beleggen.brand === 'BVS'
            )
          "
          class="edit sm-col-12 lg-colnm-6"
          @click="
            modelValue.financeData.step = null;
            modelValue.step = 5;
          "
        >
          <br /><b>Bezittingen <awesomeIcon icon="edit" /></b><br />
          <!-- Spaarrekeningen-->
          <check
            v-if="!modelValue.financeData.spaarrekening"
            :val="modelValue.financeData.spaarrekening"
            fallback="Betaal- of spaarrekening vraag nog niet beantwoord."
            style="display: block"
          />
          <template v-else>
            <template v-if="modelValue.financeData.spaarrekening === 'Yes'">
              Op betaal- of spaarrekening(en) in totaal
              <check
                :val="
                  Number(modelValue.financeData.spaarrekening2Bedrag || 0) +
                  Number(modelValue.financeData.spaarrekeningBedrag || 0) +
                  Number(modelValue.financeData.spaarrekening3Bedrag || 0)
                "
                fallback="geen bedrag"
                type="money"
              />
              bij
              <check
                :val="modelValue.financeData.spaarrekeningInstantie === 'Anders'
                  ?  modelValue.financeData.spaarrekeningInstantieOmschrijving
                  :  modelValue.financeData.spaarrekeningInstantie"
                fallback="geen instantie"
              />
              <span v-if="modelValue.financeData.spaarrekening2 == 'Yes'">, </span>
              <check
                v-if="modelValue.financeData.spaarrekening2 === 'Yes'"
                :val="modelValue.financeData.spaarrekening2Instantie === 'Anders'
                  ?  modelValue.financeData.spaarrekening2InstantieOmschrijving
                  :  modelValue.financeData.spaarrekening2Instantie"
                fallback="(geen instantie betaal- of spaarrekening 2)"
              />
              <span v-if="modelValue.financeData.spaarrekening3 === 'Yes'">, </span>
              <check
                v-if="modelValue.financeData.spaarrekening3 === 'Yes'"
                :val="modelValue.financeData.spaarrekening3Instantie === 'Anders'
                  ?  modelValue.financeData.spaarrekening3InstantieOmschrijving
                  :  modelValue.financeData.spaarrekening3Instantie"
                fallback="(geen instantie betaal- of spaarrekening 3)"
              />.<br />
            </template>
            <template v-else>Het bedrijf heeft geen betaal- of spaarrekeningen.<br /></template>
          </template>

          <!-- Beleggingen -->
          <check
            v-if="!modelValue.financeData.beleggingen"
            :val="modelValue.financeData.beleggingen"
            fallback="Beleggingsvraag nog niet beantwoord."
            style="display: block"
          />
          <template v-else>
            <template v-if="modelValue.financeData.beleggingen === 'Yes'">
              Heeft
              <check
                :val="modelValue.financeData.beleggingenBedrag"
                fallback="Geen bedrag"
                type="money"
              />
              <template
                v-if="modelValue.financeData.beleggingenTypeDienst !== 'Lening'"
              >
                belegd bij
                <check
                  :val="modelValue.financeData.beleggingenInstantie === 'Anders'
                    ?  modelValue.financeData.beleggingenInstantieOmschrijving
                    :  modelValue.financeData.beleggingenInstantie"
                  fallback="geen instantie"
                />
                met type
                <check
                  :val="modelValue.financeData.beleggingenTypeDienst"
                  fallback="(geen type)"
                />
                en profiel
                <check
                  :val="modelValue.financeData.beleggingenProfiel"
                  fallback="(geen profiel)"
                />.
              </template>
              <template v-else>
                uitgeleend.
              </template>

              <template v-if="modelValue.financeData.beleggingenMeer === 'Yes'">
                <br />
                Heeft
                <check
                  :val="modelValue.financeData.beleggingenMeerBedrag"
                  fallback="Geen bedrag"
                  type="money"
                />
                <template
                  v-if="
                    modelValue.financeData.beleggingenMeerTypeDienst !== 'Lening'
                  "
                >
                  belegd bij
                  <check
                    :val="
                      modelValue.financeData.beleggingenMeerInstantie === 'Anders'
                      ?  modelValue.financeData.beleggingenMeerInstantieOmschrijving
                      :  modelValue.financeData.beleggingenMeerInstantie
                    "
                    fallback="geen instantie"
                  />
                  met type
                  <check
                    :val="modelValue.financeData.beleggingenMeerTypeDienst"
                    fallback="(geen type)"
                  />
                  en profiel
                  <check
                    :val="modelValue.financeData.beleggingenMeerProfiel"
                    fallback="(geen profiel)"
                  />.
                </template>
                <template v-else>
                  uitgeleend.
                </template>
              </template>
              <template v-if="modelValue.financeData.beleggingenNogMeer === 'Yes'">
                <br />
                Heeft
                <check
                  :val="modelValue.financeData.beleggingenNogMeerBedrag"
                  fallback="Geen bedrag"
                  type="money"
                />
                <template
                  v-if="
                    modelValue.financeData.beleggingenNogMeerTypeDienst !== 'Lening'
                  "
                >
                  belegd bij
                  <check
                    :val="
                      modelValue.financeData.beleggingenNogMeerInstantie === 'Anders'
                      ?
                      modelValue.financeData.beleggingenNogMeerInstantieOmschrijving
                      : modelValue.financeData.beleggingenNogMeerInstantie
                    "
                    fallback="geen instantie"
                  />
                  met type
                  <check
                    :val="modelValue.financeData.beleggingenNogMeerTypeDienst"
                    fallback="(geen type)"
                  />
                  en profiel
                  <check
                    :val="modelValue.financeData.beleggingenNogMeerProfiel"
                    fallback="(geen profiel)"
                  />.
                </template>
                <template v-else>
                  uitgeleend.
                </template>
              </template>
              <br />
            </template>
            <template v-else>Het bedrijf heeft geen beleggingen.<br /></template>
          </template>

          <!-- Onroerend goed -->
          <check
            v-if="!modelValue.financeData.onroerendgoed"
            :val="modelValue.financeData.onroerendgoed"
            fallback="Onroerend goed vraag nog niet beantwoord."
            style="display: block"
          />
          <template v-else>
            <template v-if="modelValue.financeData.onroerendgoed == 'Yes'">
              <check
                v-if="!modelValue.financeData.onroerendgoedCommercieel"
                :val="modelValue.financeData.onroerendgoedCommercieel"
                fallback="Commerciële doeleinden vraag nog niet beantwoord."
                style="display: block"
              />
              De vrije verkoopwaarde van onroerend goed is
              <check
                :val="modelValue.financeData.onroerendgoedVrijeverkoopwaarde"
                fallback="geen bedrag"
                type="money"
              />
              {{
                modelValue.financeData.onroerendgoedCommercieel === 'Yes' ? '' : '.'
              }}
              <template
                v-if="modelValue.financeData.onroerendgoedCommercieel === 'Yes'"
              >
                  <br /> met een jaarlijks inkomen van
                <check
                  :val="modelValue.financeData.onroerendgoedBedragPerJaar"
                  fallback="geen bedrag"
                  type="money"
                />.<br />
              </template>
            </template>
            <template v-else>Het bedrijf heeft geen onroerend goed.<br /></template>
          </template>

          <!-- Overig onroerend goed -->
          <check
            v-if="!modelValue.financeData.overigOnroerendgoed"
            :val="modelValue.financeData.overigOnroerendgoed"
            fallback="Overig onroerend goed vraag nog niet beantwoord."
            style="display: block"
          />
          <template v-else>
            <template v-if="modelValue.financeData.overigOnroerendgoed == 'Yes'">
              <check
                v-if="!modelValue.financeData.overigOnroerendgoedCommercieel"
                :val="modelValue.financeData.overigOnroerendgoedCommercieel"
                fallback="Commerciële doeleinden vraag nog niet beantwoord."
                style="display: block"
              />
              De vrije verkoopwaarde van overig onroerend goed is
              <check
                :val="modelValue.financeData.overigOnroerendgoedVrijeverkoopwaarde"
                fallback="geen bedrag"
                type="money"
              />
              {{
                modelValue.financeData.overigOnroerendgoedCommercieel === 'Yes'
                  ? ''
                  : '.'
              }}
              <template
                v-if="
                  modelValue.financeData.overigOnroerendgoedCommercieel === 'Yes'
                "
              >
                  <br /> met een jaarlijks inkomen van
                <check
                  :val="modelValue.financeData.overigOnroerendgoedBedragPerJaar"
                  fallback="geen bedrag"
                  type="money"
                />
                <check
                  :val="modelValue.financeData.overigOnroerendgoedObjecten"
                  fallback="voor geen objecten"
                  :validtext="
                    ` voor ${modelValue.financeData.overigOnroerendgoedObjecten}
                    ${
                      modelValue.financeData.overigOnroerendgoedObjecten == '1'
                        ?  'object'
                        : 'objecten'
                    }`
                  "
                  type="money"
                />
                <template
                  v-if="
                    modelValue.financeData.overigOnroerendgoedCommercieel === 'Yes'
                  "
                >
                  <check
                    v-if="
                      modelValue.financeData.overigOnroerendgoedCommercieel === 'Yes'
                      &&
                      modelValue.financeData.overigOnroerendgoedCommercieelObjecten
                      > modelValue.financeData.overigOnroerendgoedObjecten
                    "
                    :val="
                      modelValue.financeData.overigOnroerendgoedCommercieelObjecten
                        <= modelValue.financeData.overigOnroerendgoedObjecten
                    "
                    :fallback="`
                      Commerciële objecten
                      (${
                        modelValue.financeData.overigOnroerendgoedCommercieelObjecten
                      })
                      zijn er meer dan alle objecten
                      (${modelValue.financeData.overigOnroerendgoedObjecten})
                    `"
                    :validtext="``"
                  />
                  <check
                    v-else-if="
                      modelValue.financeData.overigOnroerendgoedCommercieel === 'Yes'
                    "
                    :val="
                      modelValue.financeData.overigOnroerendgoedCommercieelObjecten
                    "
                    fallback="('geen commerciële object(en)')"
                    :validtext="`
                      (waarvan ${
                        modelValue.financeData.overigOnroerendgoedCommercieelObjecten
                      } commercieel)
                    `"
                    type="number"
                  />
                </template>.
              </template>
            </template>
            <template v-else>Het bedrijf heeft geen overig onroerend goed.<br /></template>
          </template>
        </div>

        <!-- Hypotheek (overig) onroerend goed -->
        <div
          class="edit sm-col-12 lg-colnm-6"
          @click="modelValue.financeData.step = null;modelValue.step = 5;"
          v-if="
            modelValue.rekeningData.type === 'Bedrijfsrekening'
            && (
              $parent.intakeAdmin.beleggen.brand === 'VMVB'
              || $parent.intakeAdmin.beleggen.brand === 'BVS'
            )
            && (
              modelValue.financeData.onroerendgoed === 'Yes'
              || modelValue.financeData.overigOnroerendgoed === 'Yes'
            )
          "
        >
          <br /><b>Hypotheek <awesomeIcon icon="edit" /></b><br />
          <check
            v-if="!modelValue.financeData.hypotheekVastgoed"
            :val="modelValue.financeData.hypotheekVastgoed"
            fallback="Hypotheek vraag nog niet beantwoord."
            style="display: block"
          />
          <template v-else-if="modelValue.financeData.hypotheekVastgoed === 'Yes'">
            Hypotheek
            <check
              :val="modelValue.financeData.hypotheekVastgoedType"
              fallback="hypotheektype"
              :validtext="'(' + modelValue.financeData.hypotheekVastgoedType + ')'"
            />
            van
            <check
              :val="modelValue.financeData.hypotheekVastgoedWaarde"
              fallback="bedrag"
              type="money"
            />
            <template
              v-if="
                $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen' &&
                $parent.intakeAdmin.beleggen.brand !== 'OXBY'
              "
            >
            bij
            <check
              :val="modelValue.financeData.hypotheekVastgoedInstantie === 'Anders'
                ?  modelValue.financeData.hypotheekVastgoedInstantieOmschrijving
                :  modelValue.financeData.hypotheekVastgoedInstantie"
              fallback="(geen instantie)"
            />
            </template>
            met een
            <check
              :val="modelValue.financeData.hypotheekVastgoedRenteType"
              fallback="rentetype"
              :validtext="modelValue.financeData.hypotheekVastgoedRenteType + 'e'"
            />
            rente<check
              v-if="modelValue.financeData.hypotheekVastgoedRenteType == 'vast'"
              :val="modelValue.financeData.hypotheekVastgoedRente / 100"
              fallback=" (percentage)"
              :validtext="
                'percentage van ' +
                modelValue.financeData.hypotheekVastgoedRente / 100 +
                '%'
              "
              type="percentage"
            />
            <check
              :val="
                modelValue.financeData.hypotheekVastgoedLooptijd
                  ? new Date(
                    modelValue.financeData.hypotheekVastgoedLooptijd
                    ).toLocaleDateString()
                  : null
              "
              fallback="looptijd"
              v-if="modelValue.financeData.hypotheekVastgoedRenteType == 'vast'"
              :validtext="
                ' tot ' +
                new Date(
                  modelValue.financeData.hypotheekVastgoedLooptijd
                ).toLocaleDateString()
              "
            />.<br />
            <check
              v-if="modelValue.financeData.hypotheekVastgoedRenteType == 'vast'
                && !modelValue.financeData.hypotheekVastgoedLooptijd"
              :val="modelValue.financeData.hypotheekVastgoedLooptijd"
              fallback="U heeft geen einddatum van de rentevast periode ingevuld."
              style="display: block"
            />
            <check
              v-else-if="
                modelValue.financeData.hypotheekVastgoedRenteType == 'vast'
                && !(
                  new Date(
                    modelValue.financeData.hypotheekVastgoedLooptijd
                  ) >= new Date()
                )
              "
              :val="
                new Date(
                  modelValue.financeData.hypotheekVastgoedLooptijd
                ) >= new Date()
              "
              :fallback="`Uw einddatum van de rentevast periode
                (${new Date(
                  modelValue.financeData.hypotheekVastgoedLooptijd
                ).toLocaleDateString()}) ligt in het verleden.
              `"
              style="display: block"
            />
            <check
              v-if="
                modelValue.financeData.hypotheekVastgoed == 'Yes'
                && !modelValue.financeData.hypotheekVastgoed2
              "
              :val="modelValue.financeData.hypotheekVastgoed2"
              fallback="Tweede hypotheekdeel vraag nog niet beantwoord."
              style="display: block"
            />
            <template v-if="modelValue.financeData.hypotheekVastgoed2 == 'Yes'">
              Hypotheek
              <check
                :val="modelValue.financeData.hypotheekVastgoed2Type"
                fallback="hypotheektype"
                :validtext="
                  '(' + modelValue.financeData.hypotheekVastgoed2Type + ')'
                "
              />
              van
              <check
                :val="modelValue.financeData.hypotheekVastgoed2Waarde"
                fallback="bedrag"
                type="money"
              />
              <template
                v-if="
                  $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen' &&
                  $parent.intakeAdmin.beleggen.brand !== 'OXBY'
                "
              >
              bij
              <check
                :val="modelValue.financeData.hypotheekVastgoed2Instantie === 'Anders'
                  ?  modelValue.financeData.hypotheekVastgoed2InstantieOmschrijving
                  :  modelValue.financeData.hypotheekVastgoed2Instantie"
                fallback="(geen instantie)"
              />
              </template>
              met een
              <check
                :val="modelValue.financeData.hypotheekVastgoed2RenteType"
                fallback="rentetype"
                :validtext="modelValue.financeData.hypotheekVastgoed2RenteType"
              />
              rente
              <check
                v-if="modelValue.financeData.hypotheekVastgoed2RenteType == 'vast'"
                :val="modelValue.financeData.hypotheekVastgoed2Rente / 100"
                fallback=" (percentage)"
                :validtext="
                  'percentage van ' +
                  modelValue.financeData.hypotheekVastgoed2Rente / 100 +
                  '%'
                "
                type="percentage"
              />
              <check
                :val="
                  modelValue.financeData.hypotheekVastgoed2Looptijd
                    ? new Date(
                      modelValue.financeData.hypotheekVastgoed2Looptijd
                      ).toLocaleDateString()
                    : null
                "
                fallback="looptijd"
                v-if="modelValue.financeData.hypotheekVastgoed2RenteType == 'vast'"
                :validtext="
                  ' tot ' +
                  new Date(
                    modelValue.financeData.hypotheekVastgoed2Looptijd
                  ).toLocaleDateString()
                "
              />.<br />
              <check
                v-if="modelValue.financeData.hypotheekVastgoed2RenteType == 'vast'
                  && !modelValue.financeData.hypotheekVastgoed2Looptijd"
                :val="modelValue.financeData.hypotheekVastgoed2Looptijd"
                fallback="U heeft geen einddatum van de rentevast periode ingevuld."
                style="display: block"
              />
              <check
                v-else-if="
                  modelValue.financeData.hypotheekVastgoed2RenteType == 'vast'
                  && !(new Date(
                    modelValue.financeData.hypotheekVastgoed2Looptijd
                    ) >= new Date()
                  )
                "
                :val="
                  new Date(
                    modelValue.financeData.hypotheekVastgoed2Looptijd
                  ) >= new Date()
                "
                :fallback="`Uw einddatum van de rentevast periode
                  (${new Date(
                    modelValue.financeData.hypotheekVastgoed2Looptijd
                  ).toLocaleDateString()}) ligt in het verleden.
                `"
                style="display: block"
              />
            </template>
            <check
              v-if="
                modelValue.financeData.hypotheekVastgoed2 == 'Yes'
                && !modelValue.financeData.hypotheekVastgoed3
              "
              :val="modelValue.financeData.hypotheekVastgoed3"
              fallback="Derde hypotheekdeel vraag nog niet beantwoord."
              style="display: block"
            />
            <template v-if="modelValue.financeData.hypotheekVastgoed3 == 'Yes'">
              Hypotheek
              <check
                :val="modelValue.financeData.hypotheekVastgoed3Type"
                fallback="hypotheektype"
                :validtext="
                  '(' + modelValue.financeData.hypotheekVastgoed3Type + ')'
                "
              />
              van
              <check
                :val="modelValue.financeData.hypotheekVastgoed3Waarde"
                fallback="bedrag"
                type="money"
              />
              <template
                v-if="
                  $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen' &&
                  $parent.intakeAdmin.beleggen.brand !== 'OXBY'
                "
              >
              bij
              <check
                :val="modelValue.financeData.hypotheekVastgoed3Instantie === 'Anders'
                  ?  modelValue.financeData.hypotheekVastgoed3InstantieOmschrijving
                  :  modelValue.financeData.hypotheekVastgoed3Instantie"
                fallback="(geen instantie)"
              />
              </template>
              met een
              <check
                :val="modelValue.financeData.hypotheekVastgoed3RenteType"
                fallback="rentetype"
                :validtext="modelValue.financeData.hypotheekVastgoed3RenteType + 'e'"
              />
              rente<check
                v-if="modelValue.financeData.hypotheekVastgoed3RenteType == 'vast'"
                :val="modelValue.financeData.hypotheekVastgoed3Rente / 100"
                fallback=" (percentage)"
                :validtext="
                  'percentage van ' +
                  modelValue.financeData.hypotheekVastgoed3Rente / 100 +
                  '%'
                "
                type="percentage"
              /><check
                :val="
                  modelValue.financeData.hypotheekVastgoed3Looptijd
                    ? new Date(
                      modelValue.financeData.hypotheekVastgoed3Looptijd
                      ).toLocaleDateString()
                    : null
                "
                fallback="looptijd"
                v-if="modelValue.financeData.hypotheekVastgoed3RenteType == 'vast'"
                :validtext="
                  ' tot ' +
                  new Date(
                    modelValue.financeData.hypotheekVastgoed3Looptijd
                  ).toLocaleDateString()
                "
              />.<br />
              <check
                v-if="modelValue.financeData.hypotheekVastgoed3RenteType == 'vast'
                  && !modelValue.financeData.hypotheekVastgoed3Looptijd"
                :val="modelValue.financeData.hypotheekVastgoed3Looptijd"
                fallback="U heeft geen einddatum van de rentevast periode ingevuld."
                style="display: block"
              />
              <check
                v-else-if="
                  modelValue.financeData.hypotheekVastgoed3RenteType == 'vast'
                  && !(
                    new Date(
                      modelValue.financeData.hypotheekVastgoed3Looptijd
                    ) >= new Date()
                  )
                "
                :val="
                  new Date(
                    modelValue.financeData.hypotheekVastgoed3Looptijd
                  ) >= new Date()
                "
                :fallback="`Uw einddatum van de rentevast periode
                  (${new Date(
                    modelValue.financeData.hypotheekVastgoed3Looptijd
                  ).toLocaleDateString()}) ligt in het verleden.
                `"
                style="display: block"
              />
            </template>
          </template>
          <template v-else>Het bedrijf heeft geen hypotheek.<br /></template>
        </div>
      </div>

    </div>

    <!-- Persoons gegevens -->
    <div
      class="card inset"
      v-for="(persoon, index) in filter(modelValue.persoonsData, deathFilter)"
      :key="`r${index}naam`"
    >
      <div class="row">
        <div class="sm-col-12 lg-colnm-6">
          <!-- Contact-->
          <div
            class="edit"
            @click="
              modelValue.rekeningData.step = index;
              modelValue.step = 2;
            "
          >
            <b>
              <check :val="`${persoon.type} `" fallback="Type " />
              <awesomeIcon icon="edit" />
            </b><br />
            <check
              v-if="!persoon.geslacht"
              :val="persoon.geslacht"
              fallback="Geslachtsvraag niet beantwoord."
            /><br v-if="!persoon.geslacht" />
            <check :val="persoon.voorletters" fallback="voorletters" />
            {{ persoon.tussenvoegsel }}
            <check :val="persoon.achternaam" fallback="achternaam" />
            <check
              :val="persoon.roepnaam"
              fallback="roepnaam"
              :validtext="' (' + persoon.roepnaam + ')'"
            /><br />
            <check
              v-if="persoon.sterfteDatum"
              :val="persoon.sterfteDatum"
              :validtext="`Overleden op ${
                new Date(persoon.sterfteDatum).toLocaleDateString()
              }, persoon alleen zichtbaar voor admins`"
            /><br v-if="persoon.sterfteDatum" />
            <template v-if="persoon.zelfdeAdres == 'Yes'">
              <check
                :val="modelValue.persoonsData[0].straat"
                fallback="Straat"
              />&nbsp;
              <check
                :val="modelValue.persoonsData[0].huisnummer"
                fallback="huisnummer"
              />
              {{ modelValue.persoonsData[0].toevoeging }} -
              <check
                :val="modelValue.persoonsData[0].postcode"
                fallback="postcode"
              />&nbsp;
              <check
                :val="modelValue.persoonsData[0].plaats"
                fallback="plaats"
              />,&nbsp;
              <check
                :val="modelValue.persoonsData[0].land"
                fallback="land"
              />
            </template>
            <template v-else>
              <check :val="persoon.straat" fallback="Straat" />&nbsp;
              <check :val="persoon.huisnummer" fallback="huisnummer" />
              {{ persoon.toevoeging }} -
              <check :val="persoon.postcode" fallback="postcode" />&nbsp;
              <check :val="persoon.plaats" fallback="plaats" />,&nbsp;
              <check :val="persoon.land" fallback="land" />
            </template>
            <br />
            Geboren op
            <check
              :val="persoon.geboorteDatum"
              :validtext="new Date(persoon.geboorteDatum).toLocaleDateString()"
              fallback="Geboortedatum"
            /> in
            <check
              :val="persoon.geboortplaats"
              fallback="Geboorteplaats"
            />,
            <check
              :val="persoon.geboorteland"
              fallback="Geboorteland"
            />
            <br />
            <check
              :val="persoon.bsn"
              :validtext="
                `${
                  persoon.belastingsplichtigBuitenland !== 'Yes' || modelValue.goalData.box == '1'
                    ? 'Burgerservicenummer:'
                    : 'TIN: '
                }
                ${persoon.bsn}`
              "
              :fallback="`${
                persoon.belastingsplichtigBuitenland !== 'Yes' || modelValue.goalData.box == '1'
                  ? 'Burgerservicenummer'
                  : 'TIN'
              }`"
            />
            <br />
            <check
              :val="persoon.documentnummer"
              :validtext="
                `${
                  persoon.identificationType === 'id'? 'ID-kaart' : 'Paspoort'
                } documentnummer: ${
                  persoon.documentnummer
                }`
              "
              :fallback="`${
                persoon.identificationType === 'id'? 'ID-kaart' : 'Paspoort'
              } documentnummer`"
            />
            <br />
            <check
              :val="
                new Date(persoon.vervalDatum) >= new Date()
                &&
                new Date(persoon.vervalDatum)
                <= new Date(new Date().setFullYear(new Date().getFullYear() + 100))
              "
              :validtext="`
                  ${persoon.identificationType === 'id'? 'ID-kaart' : 'Paspoort'} vervaldatum:
                  ${new Date(persoon.vervalDatum).toLocaleDateString()}
              `"
              :fallback="`Legitimatie is verlopen`"
            />
            <br />
            <check
              v-if="!persoon.usperson"
              :val="persoon.usperson"
              fallback="Zijn van US person nog niet beantwoord."
            />
            <check
              v-else
              :val="persoon.usperson === 'No'"
              fallback="Is een US person."
              validtext="Is geen US person."
            />
            <br />
            <check
              v-if="!persoon.dutchNationality"
              :val="persoon.dutchNationality"
              fallback="Hebben van Nederlandse nationaliteit nog niet beantwoord."
            />
            <template v-else-if="persoon.dutchNationality == 'No'"
              >Heeft andere nationaliteit:
              <check
                :val="persoon.nationaliteit"
                fallback="Andere nationaliteit"
            /></template>
            <template v-else>Heeft de Nederlandse nationaliteit</template><br />
            <check
              v-if="!persoon.secondNationality"
              :val="persoon.secondNationality"
              fallback="Hebben van tweede nationaliteit nog niet beantwoord."
            />
            <template v-else-if="persoon.secondNationality == 'Yes'"
              >Heeft tweede nationaliteit:
              <check
                :val="persoon.secondNationalityName"
                fallback="tweede nationaliteit"
            /></template>
            <template v-else>Geen tweede nationaliteit</template><br />
            <template v-if="persoon.type != 'Minderjarige'">
              Tel.
              <check
                :val="persoon.telefoonnummer"
                fallback="telefoonnummer"
              />
              <template v-if="persoon.telefoonnummer2">
                Extra tel. {{ persoon.telefoonnummer2 }}
              </template>
              <template
                v-if="
                  index != 0
                  && (persoon.email
                    || $parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'
                    || $parent.intakeAdmin.beleggen.brand === 'OXBY')
                "
              >
                - E-mail
                <check
                  :val="regex().test(persoon.email) ? persoon.email : ''"
                  fallback="e-mailadres"
                />
              </template>
              <template v-else-if="index != 0">
                Geen e-mailadres opgegeven
              </template>
              <template v-else>
                - E-mail {{ $parent.email }}
              </template>
            </template>
            <template v-else>
              <template v-if="persoon.telefoonnummer">
                Tel. {{ persoon.telefoonnummer }}
              </template>
              <template v-if="persoon.telefoonnummer2">
                Extra tel. {{ persoon.telefoonnummer2 }}
              </template>
              <template v-if="persoon.email">
                E-mail.
                <check
                  :val="regex().test(persoon.email) ? persoon.email : ''"
                  fallback="e-mailadres"
                />
              </template>
            </template
            ><br />
            <check
              v-if="
                !$parent.redo
                || $parent.redo && (
                  !persoon.vervalDatum
                  || new Date(Date.now()) > new Date(persoon.vervalDatum)
                )
              "
              :val="persoon.identificationType"
              fallback="Identificatie type"
              :validtext="`Identificatie type: ${persoon.identificationType}`"
              style="display: block"
            />
            <check
              v-if="
                !$parent.redo
                || $parent.redo && (
                  !persoon.vervalDatum
                  || new Date(Date.now()) > new Date(persoon.vervalDatum)
                )
              "
              :val="filesFilter(`-legitimatie${index}-`)"
              fallback="Legitimatie niet opgegeven."
              validtext="Legitimatie opgegeven."
              style="display: block"
            />
          </div>

          <!-- Checks -->
          <div
            class="edit"
            @click="
              modelValue.financeData.step = index;
              modelValue.step = 5;
            "
            v-if="financeFilter(persoon)"
          >
            <br><b>Status <awesomeIcon icon="edit" /></b><br>
            <check
              v-if="!persoon.belastingsplichtigBuitenland"
              :val="persoon.belastingsplichtigBuitenland"
              fallback="Belastingplichtig in het buitenland vraag nog niet beantwoord."
              style="display: block"
            />
            <template
              v-else-if="persoon.belastingsplichtigBuitenland == 'Yes'"
            >
              Belastingplichtig in:
              <check
                :val="persoon.belastingsplichtingLand"
                fallback="Geen land aangegeven"
              />.<br />
            </template>
            <template v-else>
              Niet belastingplichtig buiten Nederland.<br />
            </template>
            <check
              :val="persoon.insider"
              fallback="Financiële insider vraag nog niet beantwoord."
              :validtext="
                persoon.insider == 'Yes'
                  ? 'Is financiële insider.'
                  : 'Geen financiële insider.'
              "
              style="display: block"
            />
            <check
              v-if="persoon.insider == 'Yes'"
              :val="filesFilter(`-insider${index}-`)"
              fallback="Insider regeling niet opgegeven."
              validtext="Insider regeling opgegeven."
              style="display: block"
            />
          </div>
        </div>
        <div class="sm-col-12 lg-colnm-6" v-if="financeFilter(persoon)">
          <!-- Inkomen -->
          <div
            class="edit"
            @click="
              modelValue.financeData.step = index;
              modelValue.step = 5;
            "
          >
            <b>Inkomen <awesomeIcon icon="edit" /></b><br />

            <template v-if="persoon.inkomenType === 'Geen'">
              Geen inkomen.<br />
            </template>
            <template v-else>
              Inkomen wordt gerealiseerd als/uit
              <check
                style="text-transform: lowercase"
                :val="
                  persoon.inkomenType === 'Anders'
                    ? persoon.inkomenTypeAnders
                    : persoon.inkomenType
                "
                fallback="inkomentype"
              />.<br />
            </template>
            <template v-if="persoon.inkomenType !== 'Anders'">

              {{
                persoon.inkomenType == 'Pensioen'
                || persoon.inkomenType == 'Werkzoekende'
                || persoon.inkomenType == 'Uitkering'
                || persoon.inkomenType == 'Geen'
                  ? 'Was'
                  : 'Is'
              }}
              <check
                style="text-transform: lowercase"
                :val="persoon.beroep"
                fallback="beroep"
              />
              (<check
                :val="persoon.arbeidsSituatie === 'Anders'
                  ?  persoon.arbeidsSituatieAnders
                  :  persoon.arbeidsSituatie
                "
                fallback="arbeidssituatie"
                style="text-transform: lowercase"
              />) bij
              <check
                :val="persoon.bedrijf"
                fallback="Bedrijf"
              />.<br />

              {{
                persoon.inkomenType == 'Pensioen'
                || persoon.inkomenType == 'Werkzoekende'
                || persoon.inkomenType == 'Uitkering'
                || persoon.inkomenType == 'Geen'
                  ? 'Was'
                  : 'Is'
              }} werkzaam in de
              <check
                :val="persoon.branche !== 'anders'
                  ? persoon.branche
                  : persoon.brancheAnders
                "
                style="text-transform: lowercase"
                fallback="sector."
                :validtext="`sector:
                  ${persoon.branche !== 'anders'
                    ? $parent.selectedBranche(persoon)
                    : persoon.brancheAnders
                  }.
                `"
              /><br />

              {{
                persoon.inkomenType == 'Pensioen'
                || persoon.inkomenType == 'Werkzoekende'
                || persoon.inkomenType == 'Uitkering'
                || persoon.inkomenType == 'Geen'
                  ? 'Was'
                  : 'Is'
              }} werkzaam in de
              <check
                :val="
                  persoon.sector !== 'geen-van-bovenstaande' && persoon.branche !== 'anders'
                    ? persoon.sector
                    : persoon.sectorAnders
                "
                style="text-transform: lowercase"
                fallback="branche."
                :validtext="`branche:
                  ${persoon.sector !== 'geen-van-bovenstaande' && persoon.branche !== 'anders'
                    ? $parent.selectedSector(persoon)
                    : persoon.sectorAnders
                  }.
                `"
              /><br />
            </template>

            <template v-if="
              persoon.inkomenType !== 'Geen'
              && persoon.inkomenType !== 'Pensioen'
            ">
              Bruto inkomen is
              <check
                :val="persoon.jaarinkomen"
                fallback="geen waarde"
                type="money"
              />
              per jaar.<br />
            </template>

            <check
              v-if="!persoon.anderInkomen"
              :val="persoon.anderInkomen"
              fallback="Extra inkomen vraag nog niet beantwoord."
              style="display: block"
            />
            <template v-if="persoon.anderInkomen == 'Yes'">
              Extra inkomen uit
              <check
                :val="persoon.anderInkomenType === 'Anders'
                  ?  persoon.anderInkomenTypeOmschrijving
                  :  persoon.anderInkomenType"
                fallback="geen type"
              />
              van
              <check
                :val="persoon.anderInkomenPerJaar"
                fallback="geen waarde"
                type="money"
              />
              per jaar.<br />
            </template>

            <check
              v-if="
                !persoon.gezamenlijkLevensonderhoud
                && index !== 0
                && ($parent.intakeAdmin.beleggen.brand === 'VMVB'
                  || $parent.intakeAdmin.beleggen.brand === 'BVS')
              "
              :val="persoon.gezamenlijkLevensonderhoud"
              fallback="Gezamenlijk levensonderhoud vraag niet beantwoord"
            />

            <check
              v-if="
                !persoon.levensonderhoud
                && (index == 0
                  || $parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'
                  || $parent.intakeAdmin.beleggen.brand === 'OXBY'
                  || persoon.gezamenlijkLevensonderhoud === 'No'
                )
              "
              :val="persoon.levensonderhoud"
              :fallback="`${
                goalType === 'uitkerend'
                  ? 'Vaste uitgavenpatroon'
                  : 'Levensonderhoud'
              } vraag niet beantwoord.`"
            />

            <template v-if="persoon.levensonderhoud == 'ja, voldoende'">
              Voldoende voor
              {{goalType === 'uitkerend' ? 'vaste uitgavenpatroon' : 'levensonderhoud'}}.
            </template>
            <template v-if="persoon.levensonderhoud == 'ja, en kan sparen'">
              Voldoende voor
              {{goalType === 'uitkerend' ? 'vaste uitgavenpatroon' : 'levensonderhoud'}}, met
              <check
                :val="persoon.kanSparenBedrag"
                fallback="geen bedrag"
                type="money"
              /> sparen per maand.
            </template>
            <template v-if="persoon.levensonderhoud == 'nee, vanuit deze rekening'">
              Niet voldoende, er is
              <check
                :val="persoon.levensonderhoudBedragPerJaar"
                fallback="geen bedrag"
                type="money"
              />
              per jaar nodig vanuit deze rekening.
            </template>
            <template
              v-if="
                goalType === 'opbouwend'
                && persoon.levensonderhoud == 'nee, vanuit andere rekening'
              "
            >
              Niet voldoende, het wordt aangevuld vanuit een andere rekening.
            </template>
            <template v-if="goalType === 'uitkerend'">
              <br v-if="
                persoon.levensonderhoud
                && (index == 0
                  || $parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'
                  || $parent.intakeAdmin.beleggen.brand === 'OXBY'
                  || persoon.gezamenlijkLevensonderhoud === 'No'
                )"
              />
              <check
                v-if="
                  !persoon.manierVanLeven
                  && persoon.levensonderhoud
                  && (index == 0
                    || $parent.intakeAdmin.beleggen.brand === 'Doelbeleggen'
                    || $parent.intakeAdmin.beleggen.brand === 'OXBY'
                    || persoon.gezamenlijkLevensonderhoud === 'No'
                  )
                "
                :val="persoon.manierVanLeven"
                :fallback="'Aanpassen manier van leven vraag niet beantwoord'"
              />
              <template v-if="persoon.manierVanLeven">
                <template v-if="persoon.levensonderhoud === 'nee, vanuit deze rekening'">
                  Manier van leven kan
                  {{ persoon.manierVanLeven === 'No' ? 'niet' : '' }}
                  aangepast worden om voldoende inkomsten te hebben
                </template>
                <template v-else>
                  Manier van leven
                  {{ persoon.manierVanLeven === 'No'
                    ? 'moet aangepast'
                    : 'hoeft niet aangepast te'
                  }} worden
                </template>
                als de inkomsten van deze {{ $parent.intakeAdmin.beleggen.brand }} rekening lager
                worden of wegvallen.
              </template>
            </template>

            <check
              v-if="
                (persoon.land && persoon.land != 'Nederland')
                || (persoon.eigenwoning == 'No' && persoon.huur == 'Yes')
              "
              :val="filesFilter(`-inschrijvingsbewijs${index}-`)"
              fallback="Bewijs van inschrijving niet opgegeven."
              validtext="Bewijs van inschrijving opgegeven."
              style="display: block"
            />
          </div>
          <!-- Pensioen -->
          <div
            class="edit"
            @click="
              modelValue.financeData.step = index;
              modelValue.step = 5;
            "
          >
            <b>
              <br>Pensioen {{ persoon.inkomenType != 'Pensioen' ? '(verwacht)' : '' }}
              <awesomeIcon icon="edit" /><br>
            </b>
            <template v-if="persoon.inkomenType == 'Pensioen'">
              Bruto pensioen vanuit werkgever(s) en AOW in totaal
              <check :val="persoon.pensioen" fallback="geen bedrag" type="money" />
              per jaar.
            </template>
            <template v-if="persoon.persioenBeheer == 'Yes'">
              Heeft pensioen opgebouwd binnen
              <check :val="persoon.pensioenBeheerBV" fallback="geen waarde" />
              met KVK-nummer
              <check :val="persoon.pensioenBeheerKVK" fallback="geen waarde"/>.
              <br>
              <check
                :val="filesFilter(`pensioenbv`)"
                fallback="Jaarrekening BV bestand niet opgegeven."
                validtext="Jaarrekening opgegeven."
                style="display: block"
              />
            </template>
            <check
              v-if="persoon.inkomenType != 'Pensioen' && !persoon.pensioenToereikend"
              :val="persoon.pensioenToereikend"
              fallback="Pensioen toereikend vraag nog niet beantwoord."
              style="display:block"
            />
            <template v-else-if="persoon.inkomenType != 'Pensioen'">
              <template v-if="persoon.pensioenToereikend == 'Yes'">
                Heeft aangegeven dat dit pensioen toereikend is.
              </template>
              <template v-else>
                Heeft aangegeven dat dit pensioen niet toereikend is.
              </template>
            </template>
            <check
              v-if="!persoon.pensioenHeeftAanvullend"
              :val="persoon.pensioenHeeftAanvullend"
              fallback="Aanvullend pensioen vraag nog niet beantwoord."
              style="display:block"
            />
            <check
              v-if="persoon.pensioenHeeftAanvullend == 'Yes'"
              :val="persoon.pensioenAanvullend > 0"
              fallback="Schatting aanvullend pensioen heeft geen waarde."
              :validtext="
                `Schatting aanvullend pensioen (box 1) is €
                ${formatPrice(Number(persoon.pensioenAanvullend),true)},-.`
              "
              style="display:block"
            />
          </div>
        </div>
      </div>

      <div class="row" v-if="financeFilter(persoon)">
        <div class="sm-col-12 lg-colnm-6">
          <!-- Bezittingen -->
          <div
            class="edit"
            @click="
              modelValue.financeData.step = index;
              modelValue.step = 5;
            "
          >
            <br><b>Bezittingen <awesomeIcon icon="edit" /></b><br>
            <template v-if="modelValue.goalData.box !== '1'">
              Herkomst van uw startvermogen:
              <check
                :val="$parent.checkAssetOrigin(persoon)"
                fallback="niet beantwoord"
              />.<br />
              <template
                v-if="
                  persoon.herkomstVermogenAnders === 'Yes'
                  && !persoon.herkomstVermogenOmschrijving
                "
              >
                Omschrijving herkomst(anders):
                <check
                  :val="persoon.herkomstVermogenOmschrijving"
                  fallback="niet beantwoord"
                />.<br />
              </template>
              <template v-if="persoon.herkomstVermogenWoningverkoop === 'Yes'">
                Postcode woning(verkoop):
                <check
                  :val="persoon.woningVerkoopPostcode"
                  fallback="Niet beantwoord"
                />.<br />
                Huisnummer woning(verkoop):
                <check
                  :val="persoon.woningVerkoopHuisnummer"
                  fallback="Niet beantwoord"
                  :validtext="persoon.woningVerkoopHuisnummer + (persoon.woningVerkoopToevoeging
                    ? persoon.woningVerkoopToevoeging
                    : '')"
                />.<br />
              </template>
            </template>
            <check
              v-if="!persoon.spaarrekening && index !== 0"
              :val="persoon.spaarrekening"
              fallback="Betaal- of spaarrekening vraag nog niet beantwoord."
              style="display: block"
            />
            <template v-else>
              <template v-if="persoon.spaarrekening == 'Yes'">
                Op betaal- of spaarrekening(en) in totaal
                <check
                  :val="
                    Number(persoon.spaarrekeningBedrag || 0) +
                    Number(persoon.spaarrekeningBedrag2 || 0) +
                    Number(persoon.spaarrekeningBedrag3 || 0)
                  "
                  fallback="geen bedrag"
                  type="money"
                />
                bij
                <check
                  :val="persoon.spaarrekeningInstantie === 'Anders'
                    ?  persoon.spaarrekeningInstantieOmschrijving
                    :  persoon.spaarrekeningInstantie"
                  fallback="geen instantie"
                />
                <span v-if="persoon.spaarrekening2 == 'Yes'">, </span>
                <check
                  v-if="persoon.spaarrekening2 == 'Yes'"
                  :val="persoon.spaarrekeningInstantie2 === 'Anders'
                    ?  persoon.spaarrekeningInstantie2Omschrijving
                    :  persoon.spaarrekeningInstantie2"
                  fallback="(geen instantie betaal- of spaarrekening 2)"
                />
                <span v-if="persoon.spaarrekening3 == 'Yes'">, </span>
                <check
                  v-if="persoon.spaarrekening3 == 'Yes'"
                  :val="persoon.spaarrekeningInstantie3 === 'Anders'
                    ?  persoon.spaarrekeningInstantie3Omschrijving
                    :  persoon.spaarrekeningInstantie3"
                  fallback="(geen instantie betaal- of spaarrekening 3)"
                />.<br />
              </template>
              <template v-else>Heeft geen betaal- of spaarrekeningen.<br /></template>
            </template>
            <check
              v-if="!persoon.beleggingen"
              :val="persoon.beleggingen"
              fallback="Beleggingsvraag nog niet beantwoord."
              style="display: block"
            />
            <template v-else>

              <template v-if="persoon.beleggingen === 'Yes'">
                Heeft
                <check
                  :val="persoon.beleggingenBedrag"
                  fallback="Geen bedrag"
                  type="money"
                />
                <template v-if="persoon.beleggingenTypeDienst !== 'Lening'">
                  belegd bij
                  <check
                    :val="persoon.beleggingenInstantie === 'Anders'
                      ?  persoon.beleggingenInstantieOmschrijving
                      :  persoon.beleggingenInstantie"
                    fallback="geen instantie"
                  />
                  met type
                  <check
                    :val="persoon.beleggingenTypeDienst"
                    fallback="(geen type)"
                  />
                  en profiel
                  <check
                    :val="persoon.beleggingenProfiel"
                    fallback="(geen profiel)"
                  />.
                </template>
                <template v-else>
                  uitgeleend.
                </template>

                <template v-if="persoon.beleggingenMeer === 'Yes'">
                  <br />
                  Heeft
                  <check
                    :val="persoon.beleggingenMeerBedrag"
                    fallback="Geen bedrag"
                    type="money"
                  />
                  <template v-if="persoon.beleggingenMeerTypeDienst !== 'Lening'">
                    belegd bij
                    <check
                      :val="persoon.beleggingenMeerInstantie === 'Anders'
                        ?  persoon.beleggingenMeerInstantieOmschrijving
                        :  persoon.beleggingenMeerInstantie"
                      fallback="geen instantie"
                    />
                    met type
                    <check
                      :val="persoon.beleggingenMeerTypeDienst"
                      fallback="(geen type)"
                    />
                    en profiel
                    <check
                      :val="persoon.beleggingenMeerProfiel"
                      fallback="(geen profiel)"
                    />.
                  </template>
                  <template v-else>
                    uitgeleend.
                  </template>
                </template>
                <template v-if="persoon.beleggingenNogMeer === 'Yes'">
                  <br />
                  Heeft
                  <check
                    :val="persoon.beleggingenNogMeerBedrag"
                    fallback="Geen bedrag"
                    type="money"
                  />
                  <template v-if="persoon.beleggingenNogMeerTypeDienst !== 'Lening'">
                    belegd bij
                    <check
                      :val="persoon.beleggingenNogMeerInstantie === 'Anders'
                        ?  persoon.beleggingenNogMeerInstantieOmschrijving
                        :  persoon.beleggingenNogMeerInstantie"
                      fallback="geen instantie"
                    />
                    met type
                    <check
                      :val="persoon.beleggingenNogMeerTypeDienst"
                      fallback="(geen type)"
                    />
                    en profiel
                    <check
                      :val="persoon.beleggingenNogMeerProfiel"
                      fallback="(geen profiel)"
                    />.
                  </template>
                  <template v-else>
                    uitgeleend.
                  </template>
                </template>
                <br />
              </template>
              <template v-else>Heeft geen beleggingen.<br /></template>
            </template>
            <check
              v-if="!persoon.eigenwoning"
              :val="persoon.eigenwoning"
              fallback="Eigen woning vraag nog niet beantwoord."
              style="display: block"
            />
            <template v-else>
              <template v-if="persoon.eigenwoning == 'Yes'">
                De vrije verkoopwaarde van de eigen woning is
                <check
                  :val="persoon.eigenwoningVrijeverkoopwaarde"
                  fallback="geen bedrag"
                  type="money"
                />.<br />
              </template>
              <template v-else-if="persoon.zelfdeAdres !== 'Yes'">
                Heeft geen eigen woning.<br /></template>
            </template>
            <check
              v-if="!persoon.onroerendgoed"
              :val="persoon.onroerendgoed"
              fallback="Overig onroerend goed vraag nog niet beantwoord."
              style="display: block"
            />
            <template v-else>
              <template v-if="persoon.onroerendgoed == 'Yes'">
                <check
                  v-if="!persoon.onroerendgoedCommercieel"
                  :val="persoon.onroerendgoedCommercieel"
                  fallback="Commerciële doeleinden vraag nog niet beantwoord."
                  style="display: block"
                />
                De vrije verkoopwaarde van overig onroerend goed is
                <check
                  :val="persoon.onroerendgoedVrijeverkoopwaarde"
                  fallback="geen bedrag"
                  type="money"
                />
                {{persoon.onroerendgoedCommercieel === 'Yes' ? '' : '.'}}
                <template v-if="persoon.onroerendgoedCommercieel === 'Yes'">
                    <br /> met een jaarlijks inkomen van
                  <check
                    :val="persoon.onroerendgoedBedragPerJaar"
                    fallback="geen bedrag"
                    type="money"
                  />
                  <check
                    :val="persoon.onroerendgoedObjecten"
                    fallback="'voor geen objecten'"
                    :validtext="`voor ${persoon.onroerendgoedObjecten}
                    ${persoon.onroerendgoedObjecten == '1' ?  'object' : 'objecten'}`"
                    type="money"
                  />.
                </template>
              </template>
              <template v-else>Geen overig onroerend goed.</template>
            </template>
            <check
              v-if="persoon.eigenwoning == 'No'
                && !persoon.huurlasten
                && !persoon.geenWoningGeenHuurlasten
                && persoon.zelfdeAdres !== 'Yes'"
              :val="persoon.geenWoningGeenHuurlasten"
              fallback="Reden voor geen woning en geen huurlasten nog niet opgegeven."
              style="display: block"
            />
          </div>
          <!-- Hypotheek Eigen Woning -->
          <div
            class="edit"
            @click="
              modelValue.financeData.step = index;
              modelValue.step = 5;
            "
            v-if="persoon.hypotheekEigenWoning == 'Yes'"
          >
            <br /><b>Eigen woning <awesomeIcon icon="edit" /></b><br />
            Hypotheek
            <check
              :val="persoon.hypotheekEigenWoningType"
              fallback="hypotheektype"
              :validtext="'(' + persoon.hypotheekEigenWoningType + ')'"
            />
            van
            <check
              :val="persoon.hypotheekEigenWoningWaarde"
              fallback="bedrag"
              type="money"
            />
            <template
              v-if="
                $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen' &&
                $parent.intakeAdmin.beleggen.brand !== 'OXBY'
              "
            >
            bij
            <check
              :val="persoon.hypotheekEigenWoningInstantie === 'Anders'
                ?  persoon.hypotheekEigenWoningInstantieOmschrijving
                :  persoon.hypotheekEigenWoningInstantie"
              fallback="(geen instantie)"
            />
            </template>
            met een
            <check
              :val="persoon.hypotheekEigenWoningRenteType"
              fallback="rentetype"
              :validtext="persoon.hypotheekEigenWoningRenteType + 'e'"
            />
            rente<check
              v-if="persoon.hypotheekEigenWoningRenteType == 'vast'"
              :val="persoon.hypotheekEigenWoningRente / 100"
              fallback=" (percentage)"
              :validtext="
                'percentage van ' +
                persoon.hypotheekEigenWoningRente / 100 +
                '%'
              "
              type="percentage"
            />
            <check
              :val="
                persoon.hypotheekEigenWoningLooptijd
                  ? new Date(
                      persoon.hypotheekEigenWoningLooptijd
                    ).toLocaleDateString()
                  : null
              "
              fallback="looptijd"
              v-if="persoon.hypotheekEigenWoningRenteType == 'vast'"
              :validtext="
                ' tot ' +
                new Date(
                  persoon.hypotheekEigenWoningLooptijd
                ).toLocaleDateString()
              "
            />.<br />
            <check
              v-if="persoon.hypotheekEigenWoningRenteType == 'vast'
                && !persoon.hypotheekEigenWoningLooptijd"
              :val="persoon.hypotheekEigenWoningLooptijd"
              fallback="U heeft geen einddatum van de rentevast periode ingevuld."
              style="display: block"
            />
            <check
              v-else-if="persoon.hypotheekEigenWoningRenteType == 'vast'
                && !(new Date(persoon.hypotheekEigenWoningLooptijd) >= new Date())"
              :val="new Date(persoon.hypotheekEigenWoningLooptijd) >= new Date()"
              :fallback="`Uw einddatum van de rentevast periode
                (${new Date(persoon.hypotheekEigenWoningLooptijd).toLocaleDateString()})
                ligt in het verleden.`"
              style="display: block"
            />
            <check
              v-if="persoon.hypotheekEigenWoning == 'Yes' && !persoon.hypotheekEigenWoning2"
              :val="persoon.hypotheekEigenWoning2"
              fallback="Tweede hypotheekdeel vraag nog niet beantwoord."
              style="display: block"
            />
            <template v-if="persoon.hypotheekEigenWoning2 == 'Yes'">
              Hypotheek
              <check
                :val="persoon.hypotheekEigenWoning2Type"
                fallback="hypotheektype"
                :validtext="'(' + persoon.hypotheekEigenWoning2Type + ')'"
              />
              van
              <check
                :val="persoon.hypotheekEigenWoning2Waarde"
                fallback="bedrag"
                type="money"
              />
              <template
                v-if="
                  $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen' &&
                  $parent.intakeAdmin.beleggen.brand !== 'OXBY'
                "
              >
              bij
              <check
                :val="persoon.hypotheekEigenWoning2Instantie === 'Anders'
                  ?  persoon.hypotheekEigenWoning2InstantieOmschrijving
                  :  persoon.hypotheekEigenWoning2Instantie"
                fallback="(geen instantie)"
              />
              </template>
              met een
              <check
                :val="persoon.hypotheekEigenWoning2RenteType"
                fallback="rentetype"
                :validtext="persoon.hypotheekEigenWoning2RenteType"
              />
              rente
              <check
                v-if="persoon.hypotheekEigenWoning2RenteType == 'vast'"
                :val="persoon.hypotheekEigenWoning2Rente / 100"
                fallback=" (percentage)"
                :validtext="
                  'percentage van ' +
                  persoon.hypotheekEigenWoning2Rente / 100 +
                  '%'
                "
                type="percentage"
              />
              <check
                :val="
                  persoon.hypotheekEigenWoning2Looptijd
                    ? new Date(
                        persoon.hypotheekEigenWoning2Looptijd
                      ).toLocaleDateString()
                    : null
                "
                fallback="looptijd"
                v-if="persoon.hypotheekEigenWoning2RenteType == 'vast'"
                :validtext="
                  ' tot ' +
                  new Date(
                    persoon.hypotheekEigenWoning2Looptijd
                  ).toLocaleDateString()
                "
              />.<br />
              <check
                v-if="persoon.hypotheekEigenWoning2RenteType == 'vast'
                  && !persoon.hypotheekEigenWoning2Looptijd"
                :val="persoon.hypotheekEigenWoning2Looptijd"
                fallback="U heeft geen einddatum van de rentevast periode ingevuld."
                style="display: block"
              />
              <check
                v-else-if="persoon.hypotheekEigenWoning2RenteType == 'vast'
                  && !(new Date(persoon.hypotheekEigenWoning2Looptijd) >= new Date())"
                :val="new Date(persoon.hypotheekEigenWoning2Looptijd) >= new Date()"
                :fallback="`Uw einddatum van de rentevast periode
                  (${new Date(persoon.hypotheekEigenWoning2Looptijd).toLocaleDateString()})
                  ligt in het verleden.`"
                style="display: block"
              />
            </template>
            <check
              v-if="persoon.hypotheekEigenWoning2 == 'Yes' && !persoon.hypotheekEigenWoning3"
              :val="persoon.hypotheekEigenWoning3"
              fallback="Derde hypotheekdeel vraag nog niet beantwoord."
              style="display: block"
            />
            <template v-if="persoon.hypotheekEigenWoning3 == 'Yes'">
              Hypotheek
              <check
                :val="persoon.hypotheekEigenWoning3Type"
                fallback="hypotheektype"
                :validtext="'(' + persoon.hypotheekEigenWoning3Type + ')'"
              />
              van
              <check
                :val="persoon.hypotheekEigenWoning3Waarde"
                fallback="bedrag"
                type="money"
              />
              <template
                v-if="
                  $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen' &&
                  $parent.intakeAdmin.beleggen.brand !== 'OXBY'
                "
              >
              bij
              <check
                :val="persoon.hypotheekEigenWoning3Instantie === 'Anders'
                  ?  persoon.hypotheekEigenWoning3InstantieOmschrijving
                  :  persoon.hypotheekEigenWoning3Instantie"
                fallback="(geen instantie)"
              />
              </template>
              met een
              <check
                :val="persoon.hypotheekEigenWoning3RenteType"
                fallback="rentetype"
                :validtext="persoon.hypotheekEigenWoning3RenteType + 'e'"
              />
              rente<check
                v-if="persoon.hypotheekEigenWoning3RenteType == 'vast'"
                :val="persoon.hypotheekEigenWoning3Rente / 100"
                fallback=" (percentage)"
                :validtext="
                  'percentage van ' +
                  persoon.hypotheekEigenWoning3Rente / 100 +
                  '%'
                "
                type="percentage"
              /><check
                :val="
                  persoon.hypotheekEigenWoning3Looptijd
                    ? new Date(
                        persoon.hypotheekEigenWoning3Looptijd
                      ).toLocaleDateString()
                    : null
                "
                fallback="looptijd"
                v-if="persoon.hypotheekEigenWoning3RenteType == 'vast'"
                :validtext="
                  ' tot ' +
                  new Date(
                    persoon.hypotheekEigenWoning3Looptijd
                  ).toLocaleDateString()
                "
              />.<br />
              <check
                v-if="persoon.hypotheekEigenWoning3RenteType == 'vast'
                  && !persoon.hypotheekEigenWoning3Looptijd"
                :val="persoon.hypotheekEigenWoning3Looptijd"
                fallback="U heeft geen einddatum van de rentevast periode ingevuld."
                style="display: block"
              />
              <check
                v-else-if="persoon.hypotheekEigenWoning3RenteType == 'vast'
                  && !(new Date(persoon.hypotheekEigenWoning3Looptijd) >= new Date())"
                :val="new Date(persoon.hypotheekEigenWoning3Looptijd) >= new Date()"
                :fallback="`Uw einddatum van de rentevast periode
                  (${new Date(persoon.hypotheekEigenWoning3Looptijd).toLocaleDateString()})
                  ligt in het verleden.`"
                style="display: block"
              />
            </template>
          </div>

          <div
            class="edit"
            @click="
              modelValue.financeData.step = index;
              modelValue.step = 5;
            "
            v-if="
              persoon.hypotheekOnroerendGoed == 'Yes'
              || (!persoon.hypotheekOnroerendGoed && persoon.onroerendgoed == 'Yes')
            "
          >
            <br><b>Overig onroerend goed <awesomeIcon icon="edit" /></b><br>
            <!-- Hypotheek Onroerend Goed -->
            <check
              v-if="!persoon.hypotheekOnroerendGoed && persoon.onroerendgoed == 'Yes'"
              :val="persoon.hypotheekOnroerendGoed"
              fallback="Hypotheek overig onroerend goed vraag nog niet beantwoord."
            />
            <template v-else>
              Hypotheek
              <check
                :val="persoon.hypotheekOnroerendGoedType"
                fallback="hypotheektype"
                :validtext="'(' + persoon.hypotheekOnroerendGoedType + ')'"
              />
              van
              <check
                :val="persoon.hypotheekOnroerendGoedWaarde"
                fallback="bedrag"
                type="money"
              />
              met een
              <check
                :val="persoon.hypotheekOnroerendGoedRenteType"
                fallback="rentetype"
                :validtext="persoon.hypotheekOnroerendGoedRenteType + 'e'"
              />
              rente
              <check
                v-if="persoon.hypotheekOnroerendGoedRenteType == 'vast'"
                :val="persoon.hypotheekOnroerendGoedRente / 100"
                fallback=" (percentage)"
                :validtext="
                  'percentage van ' +
                  persoon.hypotheekOnroerendGoedRente / 100 +
                  '%'
                "
                type="percentage"
              />
              <check
                :val="
                  persoon.hypotheekOnroerendGoedLooptijd
                    ? new Date(
                        persoon.hypotheekOnroerendGoedLooptijd
                      ).toLocaleDateString()
                    : null
                "
                fallback="looptijd"
                v-if="persoon.hypotheekOnroerendGoedRenteType == 'vast'"
                :validtext="
                  ' tot ' +
                  new Date(
                    persoon.hypotheekOnroerendGoedLooptijd
                  ).toLocaleDateString()
                "
              />.<br />
              <check
                  v-if="persoon.hypotheekOnroerendGoedRenteType == 'vast'
                    && !(new Date(persoon.hypotheekOnroerendGoedLooptijd) >= new Date())"
                  :val="new Date(persoon.hypotheekOnroerendGoedLooptijd) >= new Date()"
                  :fallback="`De datum
                    (${new Date(persoon.hypotheekOnroerendGoedLooptijd).toLocaleDateString()})
                    van de hypotheek onroerend goed looptijd ligt in het verleden`"
                  style="display: block"
                />
              <check
                v-if="persoon.hypotheekOnroerendGoed == 'Yes'
                  && !persoon.hypotheekOnroerendGoed2"
                :val="persoon.hypotheekOnroerendGoed2"
                fallback="Tweede hypotheek overig onroerend goed vraag nog niet beantwoord."
                style="display:block"
              />
              <template v-if="persoon.hypotheekOnroerendGoed2 == 'Yes'">
                Hypotheek
                <check
                  :val="persoon.hypotheekOnroerendGoed2Type"
                  fallback="hypotheektype"
                  :validtext="'(' + persoon.hypotheekOnroerendGoed2Type + ')'"
                />
                van
                <check
                  :val="persoon.hypotheekOnroerendGoed2Waarde"
                  fallback="bedrag"
                  type="money"
                />
                met een
                <check
                  :val="persoon.hypotheekOnroerendGoed2RenteType + 'e'"
                  fallback="rentetype"
                  :validtext="persoon.hypotheekOnroerendGoed2RenteType + 'e'"
                />
                rente<check
                  v-if="persoon.hypotheekOnroerendGoed2RenteType == 'vast'"
                  :val="persoon.hypotheekOnroerendGoed2Rente / 100"
                  fallback=" (percentage)"
                  :validtext="
                    'percentage van ' +
                    persoon.hypotheekOnroerendGoed2Rente / 100 +
                    '%'
                  "
                  type="percentage"
                /><check
                  :val="
                    persoon.hypotheekOnroerendGoed2Looptijd
                      ? new Date(
                          persoon.hypotheekOnroerendGoed2Looptijd
                        ).toLocaleDateString()
                      : null
                  "
                  fallback="looptijd"
                  v-if="persoon.hypotheekOnroerendGoed2RenteType == 'vast'"
                  :validtext="
                    ' tot ' +
                    new Date(
                      persoon.hypotheekOnroerendGoed2Looptijd
                    ).toLocaleDateString()
                  "
                />.<br />
                <check
                  v-if="persoon.hypotheekOnroerendGoed2RenteType == 'vast'
                    && !(new Date(persoon.hypotheekOnroerendGoed2Looptijd) >= new Date())"
                  :val="new Date(persoon.hypotheekOnroerendGoed2Looptijd) >= new Date()"
                  :fallback="`De datum
                    (${new Date(persoon.hypotheekOnroerendGoed2Looptijd).toLocaleDateString()})
                    van de hypotheek onroerend goed looptijd ligt in het verleden`"
                  style="display: block"
                />
              </template>
              <check
                v-if="persoon.hypotheekOnroerendGoed2 == 'Yes'
                && !persoon.hypotheekOnroerendGoed3"
                :val="persoon.hypotheekOnroerendGoed3"
                fallback="Derde hypotheek overig onroerend goed vraag nog niet beantwoord."
                style="display:block"
              />
              <template v-if="persoon.hypotheekOnroerendGoed3 == 'Yes'">
                Hypotheek
                <check
                  :val="persoon.hypotheekOnroerendGoed3Type"
                  fallback="hypotheektype"
                  :validtext="'(' + persoon.hypotheekOnroerendGoed3Type + ')'"
                />
                van
                <check
                  :val="persoon.hypotheekOnroerendGoed3Waarde"
                  fallback="bedrag"
                  type="money"
                />
                met een
                <check
                  :val="persoon.hypotheekOnroerendGoed3RenteType + 'e'"
                  fallback="rentetype"
                  :validtext="persoon.hypotheekOnroerendGoed3RenteType + 'e'"
                />
                rente
                <check
                  v-if="persoon.hypotheekOnroerendGoed3RenteType == 'vast'"
                  :val="persoon.hypotheekOnroerendGoed3Rente / 100"
                  fallback=" (percentage)"
                  :validtext="
                    'percentage van ' +
                    persoon.hypotheekOnroerendGoed3Rente / 100 +
                    '%'
                  "
                  type="percentage"
                />
                <check
                  :val="
                    persoon.hypotheekOnroerendGoed3Looptijd
                      ? new Date(
                          persoon.hypotheekOnroerendGoed3Looptijd
                        ).toLocaleDateString()
                      : null
                  "
                  fallback="looptijd"
                  v-if="persoon.hypotheekOnroerendGoed3RenteType == 'vast'"
                  :validtext="
                    ' tot ' +
                    new Date(
                      persoon.hypotheekOnroerendGoed3Looptijd
                    ).toLocaleDateString()
                  "
                />.<br />
                <check
                  v-if="persoon.hypotheekOnroerendGoed3RenteType == 'vast'
                    && !(new Date(persoon.hypotheekOnroerendGoed3Looptijd) >= new Date())"
                  :val="new Date(persoon.hypotheekOnroerendGoed3Looptijd) >= new Date()"
                  :fallback="`De datum
                    (${new Date(persoon.hypotheekOnroerendGoed3Looptijd).toLocaleDateString()})
                    van de hypotheek onroerend goed looptijd ligt in het verleden`"
                  style="display: block"
                />
              </template>
            </template>
          </div>
        </div>

        <div class="sm-col-12 lg-colnm-6">
          <!-- Lasten -->
          <div
            class="edit"
            @click="
              modelValue.financeData.step = index;
              modelValue.step = 5;
            "
          >
            <br /><b>Overige verplichtingen <awesomeIcon icon="edit" /></b><br />
            <check
              v-if="persoon.eigenwoning == 'No' && !persoon.huur"
              :val="persoon.huur"
              fallback="Huurlasten vraag nog niet beantwoord."
              style="display: block"
            />
            <template v-else-if="persoon.huur == 'Yes'">
              Betaalt aan huur
              <check
                :val="persoon.huurlasten"
                fallback="bedrag"
                type="money"
              />
              per maand.<br />
            </template>
            <template v-if="persoon.schulden == 'Yes'">
              Heeft een
              <check :val="persoon.schuldenType" fallback="schuldtype" />
              van
              <check
                v-if="persoon.schuldenType != 'alimentatie'"
                :val="persoon.schuldenBedrag"
                fallback="bedrag"
                type="money"
              />
              (per maand
              <check
                :val="persoon.schuldenMaandelijks"
                fallback="bedrag"
                type="money"
              />).<br />
              <template v-if="persoon.schuldenMeer == 'Yes'">
                Heeft een
                <check
                  :val="persoon.schuldenMeerType"
                  fallback="schuldtype"
                />
                van
                <check
                  v-if="persoon.schuldenMeerType != 'alimentatie'"
                  :val="persoon.schuldenMeerBedrag"
                  fallback="bedrag"
                  type="money"
                />
                (per maand
                <check
                  :val="persoon.schuldenMeerMaandelijks"
                  fallback="bedrag"
                  type="money"
                />).<br />
              </template>
              <template v-if="persoon.schuldenMeer2 == 'Yes'">
                Heeft een
                <check
                  :val="persoon.schuldenMeer2Type"
                  fallback="schuldtype"
                />
                van
                <check
                  v-if="persoon.schuldenMeer2Type != 'alimentatie'"
                  :val="persoon.schuldenMeer2Bedrag"
                  fallback="bedrag"
                  type="money"
                />
                (per maand
                <check
                  :val="persoon.schuldenMeer2Maandelijks"
                  fallback="bedrag"
                  type="money"
                />).<br />
              </template>
              <template v-if="persoon.schuldenMeer3 == 'Yes'">
                Heeft een
                <check
                  :val="persoon.schuldenMeer3Type"
                  fallback="schuldtype"
                />
                van
                <check
                  v-if="persoon.schuldenMeer3Type != 'alimentatie'"
                  :val="persoon.schuldenMeer3Bedrag"
                  fallback="bedrag"
                  type="money"
                />
                (per maand
                <check
                  :val="persoon.schuldenMeer3Maandelijks"
                  fallback="bedrag"
                  type="money"
                />).<br />
              </template>
            </template>
            <check
              v-if="!persoon.schulden"
              :val="persoon.schulden"
              fallback="Verdere verplichtingen vraag nog niet beantwoord."
              style="display: block"
            />
            <template v-else> Geen overige verplichtingen. </template>
          </div>
          <!-- Evaring -->
          <div
            class="edit"
            @click="modelValue.step = 4"
            v-if="index == 0"
          >
            <br><b>Ervaring <awesomeIcon icon="edit" /></b><br>
            Opleidingsniveau
            <check
              :val="modelValue.experienceData.opleiding"
              fallback="opleiding"
            />.<br />
            U volgt
            <check
              :val="modelValue.experienceData.nieuws"
              fallback="periode"
              style="text-transform: lowercase"
            />
            het economisch nieuws.<br />
            <template v-if="modelValue.experienceData.ervaring == 'Yes'">
              U heeft ervaring met beleggen
              <template
                v-if="
                  $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen' &&
                  $parent.intakeAdmin.beleggen.brand !== 'OXBY'
                "
              >
                <check
                  :val="experienceInput.length > 0"
                  :validtext="`(${experienceInput})`"
                  fallback="(geen dienst)"
                  style="text-transform: lowercase"
                />
              </template>.<br />
              <check
                v-if="!modelValue.experienceData.ervaringTrackers"
                :val="modelValue.experienceData.ervaringTrackers"
                fallback="Ervaring met trackers vraag nog niet beantwoord."
              />
              <template v-else-if="modelValue.experienceData.ervaringTrackers === 'Yes'">
                Ervaring met trackers
                <check
                  :val="modelValue.experienceData.ervaringTrackersWanneer"
                  fallback="periode"
                />
                  met
                  <template v-if="modelValue.experienceData.ervaringTrackersWaarde">
                    een waarde van
                  </template>
                  <check
                    :val="modelValue.experienceData.ervaringTrackersWaarde"
                    fallback="geen trackers waarde"
                    :validtext="`
                      €${formatPrice(modelValue.experienceData.ervaringTrackersWaarde, true)}
                    `"
                  />
                  en
                  <check
                    :val="modelValue.experienceData.ervaringTrackersTransacties"
                    fallback="geen aantal transacties opgegeven."
                  />
                  <template v-if="modelValue.experienceData.ervaringTrackersTransacties">
                    transacties per jaar.
                  </template>
              </template>
              <template v-else>
                Geen ervaring met trackers.
              </template>
              <br />
              <template
                v-if="
                  $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen' &&
                  $parent.intakeAdmin.beleggen.brand !== 'OXBY'
                "
              >
                <check
                  v-if="!modelValue.experienceData.ervaringAandelen"
                  :val="modelValue.experienceData.ervaringAandelen"
                  fallback="Ervaring met aandelen vraag nog niet beantwoord."
                />
                <template v-else-if="modelValue.experienceData.ervaringAandelen === 'Yes'">
                  Ervaring met aandelen
                  <check
                    :val="modelValue.experienceData.ervaringAandelenWanneer"
                    fallback="periode"
                  />
                  met
                  <template v-if="modelValue.experienceData.ervaringAandelenWaarde">
                    een waarde van
                  </template>
                  <check
                    :val="modelValue.experienceData.ervaringAandelenWaarde"
                    fallback="geen aandelen waarde"
                    :validtext="`
                      €${formatPrice(modelValue.experienceData.ervaringAandelenWaarde, true)}
                    `"
                  />
                  en
                  <check
                    :val="modelValue.experienceData.ervaringAandelenTransacties"
                    fallback="geen aantal transacties opgegeven."
                  />
                  <template v-if="modelValue.experienceData.ervaringAandelenTransacties">
                    transacties per jaar.
                  </template>
                </template>
                <template v-else>
                  Geen ervaring met aandelen.
                </template>
                <br />
                <check
                  v-if="!modelValue.experienceData.ervaringObligaties"
                  :val="modelValue.experienceData.ervaringObligaties"
                  fallback="Ervaring met obligaties vraag nog niet beantwoord."
                />
                <template v-else-if="modelValue.experienceData.ervaringObligaties === 'Yes'">
                  Ervaring met obligaties
                  <check
                    :val="modelValue.experienceData.ervaringObligatiesWanneer"
                    fallback="periode"
                  />
                  met
                  <template v-if="modelValue.experienceData.ervaringObligatiesWaarde">
                    een waarde van
                  </template>
                  <check
                    :val="modelValue.experienceData.ervaringObligatiesWaarde"
                    fallback="geen obligaties waarde"
                    :validtext="`
                      €${formatPrice(modelValue.experienceData.ervaringObligatiesWaarde, true)}
                    `"
                  />
                  en
                  <check
                    :val="modelValue.experienceData.ervaringObligatiesTransacties"
                    fallback="geen aantal transacties opgegeven."
                  />
                  <template v-if="modelValue.experienceData.ervaringObligatiesTransacties">
                    transacties per jaar.
                  </template>
                  <br />
                </template>
                <template v-else>
                  Geen ervaring met obligaties.<br />
                </template>
                <check
                  v-if="!modelValue.experienceData.ervaringOpties"
                  :val="modelValue.experienceData.ervaringOpties"
                  fallback="Ervaring met opties vraag nog niet beantwoord."
                />
                <template v-else-if="modelValue.experienceData.ervaringOpties === 'Yes'">
                  Ervaring met opties
                  <check
                    :val="modelValue.experienceData.ervaringOptiesWanneer"
                    fallback="periode"
                  />
                  met
                  <template v-if="modelValue.experienceData.ervaringOptiesWaarde">
                    een waarde van
                  </template>
                  <check
                    :val="modelValue.experienceData.ervaringOptiesWaarde"
                    fallback="geen opties waarde"
                    :validtext="`
                      €${formatPrice(modelValue.experienceData.ervaringOptiesWaarde, true)}
                    `"
                  />
                  en
                  <check
                    :val="modelValue.experienceData.ervaringOptiesTransacties"
                    fallback="geen aantal transacties opgegeven."
                  />
                  <template v-if="modelValue.experienceData.ervaringOptiesTransacties">
                    transacties per jaar.
                  </template>
                  <br />
                </template>
                <template v-else>
                  Geen ervaring met opties.<br />
                </template>
              </template>
            </template>
            <template
              v-else-if="modelValue.experienceData.ervaring == 'No'"
            >
              U heeft geen ervaring met beleggen.<br />
            </template>
            <check
              v-else
              :val="modelValue.experienceData.ervaring"
              fallback="Ervaring met beleggen vraag nog niet beantwoord."
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Duurzaamheid -->
    <div class="card inset">
      <div class="edit" @click="modelValue.step = 13">
        <b>Duurzaamheid <awesomeIcon icon="edit" /></b><br>
        <check
          :val="modelValue.rekeningData.acceptSustainabilityText === 'Yes'"
          fallback="
            U heeft nog niet aangegeven de tekst 'Informatie en begrippen
            duurzaamheidsvoorkeuren' gelezen te hebben.
          "
          validtext="
            U geeft aan de tekst 'Informatie en begrippen
            duurzaamheidsvoorkeuren' gelezen te hebben.
          "
        />
        <br />
        <template v-if="$parent.intakeAdmin.beleggen.brand == 'Doelbeleggen'">
          <check
            v-if="!modelValue.rekeningData.sustainabilityNew"
            :val="modelValue.rekeningData.sustainabilityNew"
            fallback="Duurzaamheidsvoorkeur vraag nog niet beantwoord."
          />
          <span v-else-if="$parent.intakeAdmin.beleggen.brand == 'Doelbeleggen'">{{
            sustainableAnswers('sustainabilityNew')
          }}</span>
          <br />
          <template
            v-if="modelValue.rekeningData.sustainabilityNew === 'Ja, specifiek'"
          >
            <check
              v-if="!modelValue.rekeningData.sustainabilityEcologicPreference"
              :val="modelValue.rekeningData.sustainabilityEcologicPreference"
              fallback="
                Duurzaamheidsvoorkeur voor ecologisch- en/of duurzame beleggingsvraag nog niet
                beantwoord.
              "
            />
            <span v-else>{{sustainableAnswers('sustainabilityEcologicPreference')}}</span>
            <br />
          </template>
          <template
            v-if="
              modelValue.rekeningData.sustainabilityNew === 'Ja, specifiek'
              && modelValue.rekeningData.sustainabilityEcologicPreference === 'Nee'
            "
          >
            <check
              v-if="!modelValue.rekeningData.sustainabilityEffect"
              :val="modelValue.rekeningData.sustainabilityEffect"
              fallback="
                Rekening houden met ongunstige effecten op duurzaamheidsfactoren vraag nog niet
                beantwoord.
              "
            />
            <span v-else>{{sustainableAnswers('sustainabilityEffect')}}</span>
            <br />
          </template>
          <template
            v-if="
              modelValue.rekeningData.sustainabilityNew === 'Ja, specifiek'
              && modelValue.rekeningData.sustainabilityEcologicPreference === 'Nee'
              && modelValue.rekeningData.sustainabilityEffect === 'Ja, PAI'
            "
          >
            <check
              v-if="
              modelValue.rekeningData.sustainabilityPaiEnvironment === 'No'
              && modelValue.rekeningData.sustainabilityPaiSocial === 'No'
              && modelValue.rekeningData.sustainabilityPaiManagement === 'No'
              "
              :val="
                modelValue.rekeningData.sustainabilityPaiEnvironment === 'Yes'
                || modelValue.rekeningData.sustainabilityPaiSocial === 'Yes'
                || modelValue.rekeningData.sustainabilityPaiManagement === 'Yes'
              "
              fallback="Specifieke voorkeuren voor duurzaamheid PAI vraag nog niet beantwoord."
            />
            <template v-else>
              <span>{{sustainableAnswers('sustainabilityPaiEnvironment')}}</span>
              <br />
              <span>{{sustainableAnswers('sustainabilityPaiSocial')}}</span>
              <br />
              <span>{{sustainableAnswers('sustainabilityPaiManagement')}}</span>
            </template>
            <br />
            <check
              v-if="!modelValue.rekeningData.sustainabilityPaiConsider"
              :val="modelValue.rekeningData.sustainabilityPaiConsider"
              fallback="
                Kwalitatief of kwantitatief mee laten wegen PAI duurzaamheid vraag nog
                niet beantwoord.
              "
            />
            <template v-else>
              <span>{{sustainableAnswers('sustainabilityPaiConsider')}}</span>
            </template>
            <br />
          </template>
          <span v-if="$parent.sustainabilityPopup === 'A'">
            <br />
            U geeft aan dat u geen duurzaamheidsvoorkeuren heeft. We richten uw
            portefeuille in op basis van uw risicoprofiel. Wij bieden een portefeuille die
            ecologische en/of sociale kenmerken promoot. De kenmerken die in de portefeuille
            van ons worden gepromoot zijn een gezondere leefomgeving. Wij sluiten overtreders
            van de UN Global Compact Principes uit en beleggen niet in de productie van tabak.
          </span>

          <span v-else-if="$parent.sustainabilityPopup === 'B'">
            <br />
            U geeft aan duurzaamheidsvoorkeuren te hebben maar die heeft u niet
            gespecificeerd. Wij bieden een portefeuille die ecologische en/of sociale kenmerken
            promoot. De kenmerken die in de portefeuille van ons worden gepromoot zijn een
            gezondere leefomgeving. Wij sluiten overtreders van de UN Global Compact Principes
            uit en beleggen niet in de productie van tabak.
          </span>

          <span v-else-if="$parent.sustainabilityPopup === 'C'">
            <br />
            Bij de beantwoording van de vragen heeft u specifieke duurzaamheidsvoorkeuren
            aangegeven. Wij bieden een portefeuille die ecologische en/of sociale kenmerken promoot.
            De kenmerken die in de portefeuille van ons worden gepromoot zijn een gezondere
            leefomgeving. Wij sluiten overtreders van de UN Global Compact Principes uit en beleggen
            niet in de productie van tabak. Hiermee wordt niet of niet volledig aan uw
            duurzaamheidsvoorkeuren voldaan.
            <template v-if="!$parent.redo">
              Als u toch graag wenst te beleggen bij ons kunt u uw duurzaamheidsvoorkeuren aanpassen
              en/of uw aanvraag alsnog aan ons versturen. Wij zullen voor u dan een beleggingsplan
              opstellen dat aansluit op uw risicoprofiel en de duurzaamheidskenmerken zoals hiervoor
              genoemd maar niet op uw duurzaamheidsvoorkeuren. Als u het beleggingsplan aanvaardt,
              stemt u hiermee in. U kunt er uiteraard ook nog voor kiezen om niet akkoord te gaan
              met het beleggingsplan.
            </template>
            <template v-else>
              Als u toch graag door wilt met beleggen bij ons kunt u uw duurzaamheidsvoorkeuren
              aanpassen en/of uw wijzigingen aan ons versturen. Wij zullen voor u dan een nieuw
              beleggingsplan opstellen dat aansluit op uw risicoprofiel en de duurzaamheidskenmerken
              zoals hiervoor genoemd maar niet op uw duurzaamheidsvoorkeuren. Met het insturen van
              uw wijziging, stemt u hiermee in. Wilt u dit niet, verstuur dan uw wijziging niet en
              neem contact met ons op.
            </template>
          </span>
        </template>
        <template v-else>
          <check
            v-if="!modelValue.rekeningData.sustainability"
            :val="modelValue.rekeningData.sustainability"
            fallback="Duurzaamheidsvoorkeur vraag nog niet beantwoord."
          />
          <template v-else>
            <span v-if="modelValue.rekeningData.sustainability == 'A'">
              Helaas kunnen wij u niet voorzien van een beleggingsportefeuille die aan uw
              duurzaamheidsvoorkeuren tegemoetkomt.<br>
              Als u desondanks toch graag wenst te beleggen bij ons, dan kunt u uw aanvraag alsnog
              aan ons versturen.<br>
              Wij zullen voor u dan een beleggingsplan opstellen dat aansluit op uw risicoprofiel
              maar niet op duurzaamheidsvoorkeuren.
              <br /><br />
              Als u dit beleggingsplan later in het traject aanvaardt, stemt u hiermee in.<br>
              U kunt er uiteraard ook nog voor kiezen om niet akkoord te gaan met het
              beleggingsplan.
            </span>
            <span v-else>
              U heeft aangegeven dat u geen duurzaamheidsvoorkeuren heeft.<br>
              Wij zullen daarom een beleggingsplan opstellen dat geen rekening houdt met
              duurzaamheidsvoorkeuren.
            </span>
          </template>
        </template>
      </div>
    </div>

    <!-- Geld overmaken -->
    <div class="card inset flex-container flex-grow">
      <div class="edit sm-col-12 lg-colnm-6" @click="modelValue.step = 12">
        <b>Geld overmaken <awesomeIcon icon="edit" /></b><br>
        <check
          :val="$parent.checkIban(modelValue.rekeningData.iban)"
          fallback="Tegenrekening IBAN niet correct."
          :validtext="`IBAN ${modelValue.rekeningData.iban.toUpperCase()}`"
        />
        <check
          v-if="$parent.checkIban(modelValue.rekeningData.iban) && checkIbanSame()"
          :val="!checkIbanSame"
          fallback="
            Vaste tegenrekening mag niet hetzelfde zijn als het rekeningnummer van een
            overdracht.
          "
          style="display:block"
        />
        <check
          v-if="
            modelValue.goalData.type != 'netto-lijfrente-uitkerend'
            && modelValue.goalData.type != 'gouden-handdruk-uitkerend'
            && modelValue.goalData.type != 'gouden-handdruk-opbouwend'
            && modelValue.goalData.type != 'levensonderhoud'
          "
          :val="modelValue.goalData.collect"
          fallback="Automatische incasso vraag niet beantwoord."
          :validtext="
            `Automatische incasso ${modelValue.goalData.collect == 'Yes' ? 'aan' : 'uit'}.`
          "
          style="display:block"
        />
        <template
          v-if="
            modelValue.goalData.type == 'netto-lijfrente-uitkerend'
            || modelValue.goalData.type == 'gouden-handdruk-uitkerend'
            || (modelValue.goalData.type == 'levensonderhoud' && modelValue.goalData.box == '1')
          "
        >
          <check
            v-if="modelValue.goalData.type != 'netto-lijfrente-uitkerend'"
            :val="modelValue.rekeningData.loonheffingskorting"
            fallback="Loonheffingskorting niet ingevuld."
            :validtext="
              `Loonheffingskorting
              ${modelValue.rekeningData.loonheffingskorting == 'Yes' ? 'wel' : 'niet'}
              toegepast.`
            "
            style="display:block"
          />
          <check
            v-if="
              modelValue.goalData.type == 'levensonderhoud'
              && modelValue.goalData.box == '1'
            "
            :val="modelValue.rekeningData.uitzonderingloonheffing"
            fallback="Uitzondering loonheffing niet ingevuld."
            :validtext="
              `Heeft ${modelValue.rekeningData.uitzonderingloonheffing == 'Yes' ? 'een' : 'geen'}
              uitzondering op loonheffing.`
            "
            style="display:block"
          />
          <check
            v-if="modelValue.rekeningData.uitzonderingloonheffing == 'Yes'"
            :val="Number(modelValue.rekeningData.exemptionFiles) > 0"
            fallback="Geen uitzondering loonheffing bestanden geüpload."
            validtext="Uitzondering loonheffing bestanden geüpload."
            style="display:block"
          />
          <check
            v-if="
              modelValue.rekeningData.uitzonderingloonheffing == 'Yes'
              && Number(modelValue.rekeningData.uitzonderingloonheffingBedrag) > 0
            "
            :val="Number(modelValue.rekeningData.uitzonderingloonheffingBedrag) > 0"
            :validtext="`De uitzondering op loonheffing is  €${
              formatPrice(modelValue.rekeningData.uitzonderingloonheffingBedrag, true)
            }.`"
            style="display:block"
          />
          <check
            v-if="
              modelValue.rekeningData.uitzonderingloonheffing == 'Yes'
              && modelValue.rekeningData.uitzonderingloonheffingDatum
            "
            :val="true"
            :validtext="`De uitzondering op loonheffing loopt tot ${
              new Date(modelValue.rekeningData.uitzonderingloonheffingDatum).toLocaleDateString()
            }.`"
            style="display:block"
          />
          <check
            v-if="
              modelValue.rekeningData.uitzonderingloonheffing == 'Yes'
              && (
                !modelValue.rekeningData.uitzonderingloonheffingDatum
                || Number(modelValue.rekeningData.uitzonderingloonheffingBedrag) === 0
              )
            "
            :val="false"
            fallback="
              Geef op tot wanneer de uitzondering op loonheffing loopt of hoe hoog deze is.
            "
            style="display:block"
          />
          <check
            v-if="!$parent.redo"
            :val="
              modelValue.rekeningData.paymentStart === '0'
              || modelValue.rekeningData.paymentStart > 0
            "
            fallback="Uitkering startdatum niet ingevuld."
            :validtext="`U heeft aangegeven ${
              modelValue.rekeningData.paymentStart === '0'
              ? 'zo snel mogelijk'
              : `niet eerder dan ${
                  new Date(new Date($parent.created).setMonth(
                    new Date($parent.created).getMonth() + Number(
                      modelValue.rekeningData.paymentStart
                    )
                  )).toLocaleString('nl-NL', { year: 'numeric', month: 'long' })
                }`
            }  te willen starten met uitkeren.`"
          />
        </template>
      </div>
      <template v-if="modelValue.goalData.collect == 'Yes'">
        <p style="margin: 0" class="sm-col-12 lg-colnm-6">
          <b>Doorlopende machtiging {{ $parent.intakeAdmin.beleggen.brand }}</b><br />
          Stichting Collectieve Beleggersgiro<br />
          Dorpsstraat 34, 1182 JE Amstelveen, Nederland<br />
          Incassant ID: NL22ZZZ625035020000<br />
          Kenmerk machtiging: {{ modelValue.rekeningData.iban }}<br />
          Reden betaling: periodieke inleg {{ $parent.intakeAdmin.beleggen.brand }}
        </p>
      </template>
      <p v-else>
        Bij het periodiek storten zonder automatische incasso, dient u zelf zorg
        te dragen voor het overboeken van het geld. U kunt daarvoor uw
        periodieke storting instellen via online bankieren. Let op: de
        haalbaarheid van uw doel is mede afhankelijk van uw periodieke
        stortingen. Wanneer u per ongeluk een storting vergeet, daalt uw
        haalbaarheid.
      </p>
    </div>

    <!-- Samenstelling normaal controle -->
    <div
      class="card accountcopy"
      v-if="
        filter(filter(modelValue.persoonsData, financeFilter), deathFilter).length == 0
        && modelValue.rekeningData.type === 'Particuliere rekening'
        && !$parent.redo
      "
    >
      <div style="padding: 20px 35px">
        <check
          :val="0"
          fallback="Een rekening moet minimaal 1 rekeninghouder bevatten."
        />
      </div>
    </div>

    <!-- samenstelling bedrijf controle -->
    <div
      class="card accountcopy"
      v-if="
        !(
          filter(
            filter(modelValue.persoonsData, deathFilter),
            { type: 'UBO/Bestuurder' },
          ).length > 0
          ||
          (
            filter(
              filter(modelValue.persoonsData, deathFilter),
              { type: 'UBO' },
              ).length > 0
            && filter(
              filter(modelValue.persoonsData, deathFilter),
              { type: 'Bestuurder' },
            ).length > 0
          )
        )
        && modelValue.rekeningData.type === 'Bedrijfsrekening'
      "
    >
      <div style="padding: 20px 35px">
        <check
          :val="0"
          :fallback="`
            Een rekening moet minimaal 1 UBO en 1 bestuurder bevatten.
            De rol kan door een en hetzelfde persoon vervuld worden.
          `"
        />
      </div>
    </div>

    <!-- Kosten financieel adviseur -->
    <div
      class="card inset"
      v-if="
        modelValue.atpData
        && modelValue.atpData.connected
        && modelValue.atpData.kosten === 'Yes'
      "
    >
      <b>Kosten van uw financieel adviseur</b><br />
      U vraagt ons om de kosten van uw financieel adviseur ten behoeve van uw beleggingsrekening
      te incasseren van deze beleggingsrekening bij {{ $parent.intakeAdmin.beleggen.brand }}.
      Dat komt neer op bij aanvang eenmalig &euro;
      {{
        modelValue.atpData.vergoedingEenmalig
        ? formatPrice(modelValue.atpData.vergoedingEenmalig)
        : '0'
      }}, een vast bedrag van &euro;
      {{
        modelValue.atpData.vergoedingJaar
        ? formatPrice(modelValue.atpData.vergoedingJaar)
        : '0'
      }} per jaar en
      {{
        modelValue.atpData.vergoedingPercentageJaar
        ? formatPrice(modelValue.atpData.vergoedingPercentageJaar / 100)
        : '0'
      }}% van de portefeuillewaarde per jaar.
    </div>

    <!-- Overdrachten -->
    <div
      v-if="!$parent.redo && modelValue.goalData.box === '1'"
      class="card accountcopy"
      @click="modelValue.step = 12;"
    >
      <div class="edit row" style="padding: 20px 35px">
        <b>Herkomst kapitaal <awesomeIcon icon="edit" /></b><br />
        <div style="margin-bottom: 30px;">
          <check
            class="sm-col-12 lg-colnm-12"
            v-if="
              (
                modelValue.goalData.type === 'levensonderhoud'
                || modelValue.goalData.type === 'gouden-handdruk-opbouwend'
                || modelValue.goalData.type === 'gouden-handdruk-uitkerend'
                || modelValue.goalData.type === 'netto-lijfrente-uitkerend'
              )
              && filter(modelValue.transferData.overdrachten, 'bedrag').length == 0
            "
            :val="filter(modelValue.transferData.overdrachten, 'bedrag').length > 0"
            fallback="Geen overdrachten aangeleverd."
          />

          <check
            class="sm-col-12 lg-colnm-12"
            v-else-if="
            !$parent.redo
            && (
                  (
                    modelValue.goalData.type !== 'pensioen'
                    && modelValue.goalData.box === '1'
                  )
                  && modelValue.goalData.type !== 'netto-lijfrente-opbouwend'
                  && modelValue.goalData.type !== 'levensonderhoud'
                  && modelValue.goalData.type !== 'gouden-handdruk-uitkerend'
                  && modelValue.goalData.type !== 'netto-lijfrente-uitkerend'
              )
            && (sumBy(
              modelValue.transferData.overdrachten,
              o => Number(o.bedrag)
            ) - Number(modelValue.goalData.vermogen) < 0)"
            :val="false"
            :fallback="`Uw overdracht bedrag (€ ${
              formatPrice(
                Number(sumBy(
                  filter(modelValue.transferData.overdrachten, 'bedrag'),
                  o => Number(o.bedrag),
                )),
                true
              )
              },-) is lager dan de inleg (€ ${
                formatPrice(
                  Number(modelValue.goalData.vermogen),
                  true
                )
              },-) die u bij uw doel heeft ingevuld.`
            "
          />

          <check
            class="sm-col-12 lg-colnm-12"
            v-else-if="
            !$parent.redo
            && modelValue.goalData.type !== 'levensonderhoud'
            && modelValue.goalData.type !== 'gouden-handdruk-uitkerend'
            && modelValue.goalData.type !== 'netto-lijfrente-uitkerend'
            && (sumBy(
              modelValue.transferData.overdrachten,
              o => Number(o.bedrag)
            ) - Number(modelValue.goalData.vermogen) > 0)"
            :val="false"
            :fallback="`Uw overdracht bedrag (€ ${
              formatPrice(
                Number(sumBy(
                  filter(modelValue.transferData.overdrachten, 'bedrag'),
                  o => Number(o.bedrag),
                )),
                true
              )
            },-) is hoger dan de inleg (€ ${
              formatPrice(
                Number(modelValue.goalData.vermogen),
                true
              )
            },-) die u bij uw doel heeft ingevuld.`"
          />
        </div>

        <template v-if="
          (
            modelValue.goalData.type === 'pensioen'
            || modelValue.goalData.type === 'netto-lijfrente-opbouwend'
          )
          && (
            !$parent.redo
            && Number(modelValue.goalData.vermogen)
              - Number(sumBy(
                filter(modelValue.transferData.overdrachten, 'bedrag'),
                o => Number(o.bedrag),
              )) > 0
          )
        ">
          <h4>
            Kapitaal uit  jaar/reserveringsruimte
          </h4>
          <span>
            &euro;&nbsp;{{
            formatPrice(
              Number(modelValue.goalData.vermogen)
              - Number(sumBy(
                filter(modelValue.transferData.overdrachten, 'bedrag'),
                o => Number(o.bedrag),
              )), true)
            }}
          </span>
        </template>

        <h4 v-if="Number(sumBy(
            filter(modelValue.transferData.overdrachten, 'bedrag'),
            o => Number(o.bedrag),
          )) > 0"
        >
          Kapitaal uit overdracht(en)
        </h4>
        <div v-for="(overdracht, overdrachtIndex) in filter(
            modelValue.transferData.overdrachten, 'bedrag'
          )"
          class="sm-col-12 lg-colnm-6"
          :key="overdrachtIndex"
        >
          <h4>
            Overdracht {{overdrachtIndex + 1}}
            ({{readableTransferName(overdracht.overdrachtType)}})
          </h4>
          <!-- Documenten checks -->
          <template v-if="overdracht.overdrachtType === 'psk' && !overdracht.files">
            <check
              :val="overdracht.files"
              fallback="Geen polisblad aangeleverd."
            /><br />
          </template>
          <template v-else-if="overdracht.overdrachtType === 'psk'
            && overdracht.files"
          >
            Polisblad aangeleverd.<br />
          </template>

          <template v-if="overdracht.overdrachtType === 'bv' && !overdracht.files">
            <check
              :val="overdracht.files"
              fallback="Geen kapitaal overeenkomst en/of jaarrekening aangeleverd."
            /><br />
          </template>
          <template v-else-if="overdracht.overdrachtType === 'bv'
            && overdracht.files"
          >
            Kapitaal overeenkomst en/of jaarrekening aangeleverd.<br />
          </template>

          <!-- IBAN check-->
          <check
            v-if="overdracht.overdrachtType === 'bv'"
            :val="overdracht.iban"
            fallback="IBAN-nummer is niet ingevuld."
            :validtext="`IBAN: ${overdracht.iban}`"
          />
          <check
            v-if="overdracht.overdrachtType === 'psk2' || overdracht.overdrachtType === 'intern'"
            :val="overdracht.iban"
            fallback="Rekeningnummer instelling niet ingevuld."
            :validtext="`Rek. nummer: ${overdracht.iban}`"
          />
          <br
            v-if="(
              overdracht.overdrachtType === 'bv'
              || overdracht.overdrachtType === 'psk2'
              || overdracht.overdrachtType === 'intern'
            )"
          />
          <!-- Instelling naam check-->
          <check
            v-if="(
              overdracht.overdrachtType === 'psk'
              || overdracht.overdrachtType === 'psk2'
            )"
            :val="overdracht.instellingNaam === 'Anders'
              ? overdracht.instellingNaamOmschrijving
              : overdracht.instellingNaam"
            fallback="Geen instantie naam opgegeven."
          />
          <span v-if="overdracht.overdrachtType === 'intern'">
            Doelbeleggen
          </span>
          <br
            v-if="(
              overdracht.overdrachtType === 'psk'
              || overdracht.overdrachtType === 'psk2'
              || overdracht.overdrachtType === 'intern'
            )"
          />
          <!-- polisnummer check-->
          <check
            v-if="overdracht.overdrachtType === 'psk'"
            :val="overdracht.polisnummer"
            fallback="Polisnummer is niet opgegeven."
            :validtext="`Polisnummer: ${overdracht.polisnummer}.`"
          />
          <br
            v-if="overdracht.overdrachtType === 'psk'"
          />
          <!-- Type kapitaal check-->
          <check
            v-if="overdracht.overdrachtType === 'bv'"
            :val="overdracht.kapitaalType"
            fallback="Geen kapitaal type gekozen."
            :validtext="`Kapitaal type: ${overdracht.kapitaalType}.`"
          />
          <br
            v-if="overdracht.overdrachtType === 'bv'"
          />
          <!-- Bedrag check-->
          <check
            :val="overdracht.bedrag"
            fallback="Geen bedrag opgegeven."
            :validtext="`Bedrag: € ${ formatPrice(overdracht.bedrag, true)},-`"
          />
          <br />
        </div>

        <div
          v-if="!$parent.redo && filter(
            modelValue.transferData.overdrachten,
            (o) =>
              (o.overdrachtType === 'psk' || o.overdrachtType === 'psk2')
              && Number(o.bedrag) > 0
              && (
                o.instellingNaam === 'NationaleNederlanden'
                || o.instellingNaam === 'Scildon'
              )
            ).length > 0
          "
          style="margin-top: 135px"
        >
          <h4>Kopie bankafschrift</h4>
          <div class="sm-col-12">
            <check
              v-if="
                !$parent.redo
              "
              :val="filesFilter(`kopie-bankafschrift`)"
              fallback="Kopie bankafschrift niet opgegeven."
              validtext="Kopie bankafschrift opgegeven."
              style="display: block"
            />
          </div>
        </div>

      </div>
    </div>

    <!-- overeenkomst uitkeren -->
    <div class="card inset" v-if="!$parent.redo && offerSelected">
      <b>U weet wat u koopt</b><br>
      Het is voor u en voor ons belangrijk dat u weet wat u koopt en dat onze afspraken duidelijk
      zijn. Daarom vragen we u om de punten hieronder zorgvuldig na te lopen.
      <template v-if="modelValue.goalData.type == 'levensonderhoud'">
        Indien u uw oud-regime lijfrentepolis (ingangsdatum voor 1-1-1992) overdraagt naar de
        Leefrente, gaan mogelijkheden die gelden voor het oud-regime van uw lijfrente verloren.
        U heeft aangegeven dat u zich daarvan bewust bent en dat u dit accepteert.
        <br><br>
      </template>
      U heeft de
      <a
        v-if="modelValue.goalData.type == 'levensonderhoud'"
        href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Leefrente.pdf"
      >
        Voorwaarden Leefrente
      </a>
      <a
        v-if="modelValue.goalData.type == 'netto-lijfrente-uitkerend'"
        href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Netto-Leefrente.pdf"
      >
        Voorwaarden Netto Lijfrente
      </a>
      <a
        v-if="modelValue.goalData.type == 'gouden-handdruk-uitkerend'"
        href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Gouden-handdruk.pdf"
      >
        Voorwaarden Gouden Handdruk
      </a>
      en het indicatief uitkeringsschema gelezen en begrepen.
      U heeft daar o.a. gezien;<br><br>
      a. wat het effect is van inflatie op uw beleggingsrekening kapitaal en uitkering;<br>
      b. dat aan beleggen risico's zijn verbonden;<br>
      c. en uw uitkering het ene jaar hoger of lager kan zijn dan het andere jaar.
    </div>
    <div class="card inset"
      v-if="
        Number(modelValue.step) === 6
        && (showCollect || showTerms || showAtp)
      "
    >
      <div v-if="!$parent.redo">
        <b>Voorwaarden &amp; machtigingen</b>
      </div>
      <div v-else>
        <b>Machtiging</b>
      </div>
      <div class="content">
        <!-- Collect terms -->
        <div v-if="showCollect">
          <h4>({{ termNumber('collect') }}) Machtiging automatische incasso</h4>
          Door akkoord te gaan met de voorwaarden voor de automatisch incasso, geeft u
          toestemming aan {{ $parent.intakeAdmin.beleggen.brand }} (Stichting Collectieve
          Beleggersgiro) om doorlopende incasso-opdrachten te sturen naar uw bank voor het van uw
          rekening afschrijven van een bedrag overeenkomstig aan de opdracht van
          {{ $parent.intakeAdmin.beleggen.brand }}. Het overeengekomen bedrag zoals door u als
          periodieke storting aangegeven, wordt altijd op de 1e werkdag van de maand bij u
          afgeschreven.
          <br /><br />
          Als u het niet eens bent met een incasso afschrijving, dan kunt u deze laten
          terugboeken. Neem hiervoor binnen 8 weken na afschrijving contact op met uw bank.
          Vraag uw bank naar de voorwaarden. Wanneer binnen deze 8 weken beleggingen voor u
          zijn aangekocht, worden deze weer verkocht om uw geld terug te kunnen boeken.
          <template v-if="$parent.redo">
            <br /><br />
          </template>
        </div>
        <!-- atp terms -->
        <div v-if="showAtp">
          <h4>({{ termNumber('atp') }}) Machtiging adviseur</h4>
          Door akkoord te gaan met de machtiging van uw adviseur geeft u ons toestemming om de
          kosten van uw financieel adviseur op deze beleggingsrekening te incasseren.
          <br />
        </div>
        <div v-if="showTerms">
          <!-- Agreement -->
          <h4>({{ termNumber('term') }}) Overeenkomst</h4>
          Wij gaan voor u beleggen, hiervoor dient u een overeenkomst met ons af te sluiten. Dat
          doet u door de inhoud van dit document en alle bijbehorende documenten te accepteren.
          Deze overeenkomst geldt ook voor rekeningen die u later bij ons aanvraagt.
          <ol>
            <li>
              {{ $parent.intakeAdmin.beleggen.brand }} is verantwoordelijk voor het beheer en
              administreren van uw beleggingen. {{ $parent.intakeAdmin.beleggen.brand }} bepaalt
              volgens welk beleggingsprofiel voor u wordt belegd en welke beleggingen daarbinnen
              worden gekocht of verkocht. Ook voert {{ $parent.intakeAdmin.beleggen.brand }} deze
              orders uit om de beleggingen te verkopen of te kopen. Wij hebben daarover afspraken
              met u gemaakt.
            </li>
            <li>
              Uw beleggingen worden niet door {{ $parent.intakeAdmin.beleggen.brand }} bewaard,
              maar door een onafhankelijk bewaarbedrijf. Dit vinden wij belangrijk en het moet ook
              van de wet. Zo zijn uw beleggingen bij een eventueel faillissement van
              {{ $parent.intakeAdmin.beleggen.brand }} veilig.
              {{ $parent.intakeAdmin.beleggen.brand }} vraagt uw beleggingsrekening aan bij de
              Stichting Collectieve Beleggersgiro.
            </li>
            <li>
              Uw beleggingsrekening werkt anders dan een gewone bankrekening. U kunt er niet voor
              langere tijd geld op hebben staan. Als u geld stort, wordt dat altijd meteen voor u
              belegd. Beleggen in geldmarktfondsen is een integraal onderdeel van uw
              beleggingsportefeuille.
            </li>
            <li>
              {{ $parent.intakeAdmin.beleggen.brand }} staat onder toezicht van de Autoriteit
              Financiële Markten (AFM) en De Nederlandsche Bank (DNB).
            </li>
          </ol>
          <!-- terms -->
          <h4>Voorwaarden &amp; bijlagen</h4>
          Voordat u akkoord gaat met onze algemene voorwaarden, dient u eerst alle voorwaarden
          goed te lezen. Hieronder zijn alle voorwaarden en bijlagen waarmee u akkoord gaat voor u
          op een rijtje gezet. Deze worden ook naar u gestuurd via e-mail.
          <div class="row" v-if="$parent.intakeAdmin.beleggen.brand == 'Doelbeleggen'">
            <ul class="sm-col-12 lg-colnm-4" style="padding-left: 13px">
              <li>
                <a
                  target="_blank"
                  href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Doelbeleggen.pdf"
                >
                  Voorwaarden Doelbeleggen
                </a>
              </li>
              <li
                v-if="
                  modelValue.goalData.type == 'levensonderhoud' &&
                  modelValue.goalData.box == '1'
                "
              >
                <a
                  target="_blank"
                  href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Leefrente.pdf"
                >
                  Voorwaarden Leefrente
                </a>
              </li>
              <li
                v-if="
                  (modelValue.goalData.type == 'gouden-handdruk-opbouwend'
                  || modelValue.goalData.type == 'gouden-handdruk-uitkerend')
                  && modelValue.goalData.box == '1'
                "
              >
                <a
                  target="_blank"
                  href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Gouden-handdruk.pdf"
                >
                  Voorwaarden Gouden Handdruk
                </a>
              </li>
              <li
                v-if="
                  (modelValue.goalData.type == 'netto-lijfrente-opbouwend'
                  || modelValue.goalData.type == 'netto-lijfrente-uitkerend')
                  && modelValue.goalData.box == '1'
                "
              >
                <a
                  target="_blank"
                  href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Netto-Leefrente.pdf"
                >
                  Voorwaarden Netto Lijfrente
                </a>
              </li>
              <li
                v-if="
                  modelValue.goalData.type == 'pensioen' &&
                  modelValue.goalData.box == '1'
                "
              >
                <a
                  target="_blank"
                  href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Pensioenrekening.pdf"
                >
                  Voorwaarden pensioen
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Beleggingsrekening.pdf"
                >
                  Voorwaarden beleggingsrekening
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.doelbeleggen.nl/content/uploads/Tarievenoverzicht.pdf"
                >
                  Tarievenoverzicht
                </a>
              </li>
            </ul>
            <ul class="sm-col-12 lg-colnm-4" style="padding-left: 13px">
              <li>
                <a
                  target="_blank"
                  href="https://www.doelbeleggen.nl/content/uploads/Orderuitvoeringsbeleid.pdf"
                >
                  Orderuitvoeringsbeleid
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.doelbeleggen.nl/content/uploads/Risicos-en-kenmerken-van-beleggen.pdf"
                >
                  Risico's en kenmerken van effecten
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.doelbeleggen.nl/esg-beleid-duurzaam-beleggen/duurzaam-beleggen/"
                >
                  Duurzaam beleggen
                </a>
              </li>
            </ul>
            <ul class="sm-col-12 lg-colnm-4" style="padding-left: 13px">
              <li>
                <a
                  target="_blank"
                  href="https://www.doelbeleggen.nl/content/uploads/Klachtenregeling.pdf"
                >
                  Klachtenregeling
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.doelbeleggen.nl/content/uploads/Regels-Belangenconflicten.pdf"
                >
                  Regels belangenconflicten
                </a>
              </li>
            </ul>
          </div>
          <div class="row" v-if="$parent.intakeAdmin.beleggen.brand == 'OXBY'">
            <ul class="sm-col-12 lg-colnm-4" style="padding-left: 13px">
              <li>
                <a
                  target="_blank"
                  href="https://oxby.nl/content/uploads/2019/03/Voorwaarden-Oxby.pdf"
                >
                  Voorwaarden OXBY Vermogensbeheer
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://oxby.nl/content/uploads/2019/03/Voorwaarden-beleggingsrekening.pdf"
                >
                  Voorwaarden beleggingsrekening
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://oxby.nl/content/uploads/2019/03/Tarievenoverzicht.pdf"
                >
                  Tarievenoverzicht
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://oxby.nl/content/uploads/Duurzaamheid.pdf"
                >
                  Duurzaam beleggen
                </a>
              </li>
            </ul>
            <ul class="sm-col-12 lg-colnm-4" style="padding-left: 13px">
              <li>
                <a
                  target="_blank"
                  href="https://oxby.nl/content/uploads/2019/03/Orderuitvoeringsbeleid.pdf"
                >
                  Orderuitvoeringsbeleid
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://oxby.nl/content/uploads/2019/03/Regels-belangenconflicten.pdf"
                >
                  Regels belangenconflicten
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://oxby.nl/content/uploads/2019/03/Risicos-en-kenmerken-van-effecten.pdf"
                >
                  Risico's en kenmerken van effecten
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://oxby.nl/content/uploads/2019/03/Klachtenregeling.pdf"
                >
                  Klachtenregeling
                </a>
              </li>
            </ul>
          </div>
          {{ $parent.intakeAdmin.beleggen.brand }} en de beleggersgiro kunnen hun overeenkomst
          en/of voorwaarden wijzigen. U gaat er met het accepteren van deze overeenkomst mee
          akkoord dat nieuwe voorwaarden per e-mail naar u kunnen worden opgestuurd.
          <br /><br />
          <!-- Important info -->
          <h4>Belangrijk</h4>
          Begrijpt u bepaalde voorwaarden niet? Of mist u bepaalde voorwaarden? Klik dan niet op
          'Rekening aanvragen' en neem contact met ons op.
        </div>
      </div>
      <div class="msg error icon" v-if="invalidCollect || invalidTerms || invalidAtp">
        <div class="icon">
        <awesomeIcon icon="info-circle"/>
        </div>
        Let op, u dient akkoord te gaan met alle
        {{$parent.redo ? 'machtigingen' : 'voorwaarden/machtigingen'}} om verder te gaan.
      </div>
      <customInput
        v-if="showCollect"
        style="border: 1px solid grey"
        v-model="modelValue.acceptCollectTerms"
        type="yesno2"
        :label="
          `Ik ga akkoord met de machtiging van de automatische incasso (${termNumber('collect')})`
        "
        boxtype="checkbox"
      />
      <customInput
        v-if="showAtp"
        style="border: 1px solid grey"
        v-model="modelValue.acceptAtpTerms"
        type="yesno2"
        :label="`Ik ga akkoord met de machtiging van de adviseur (${termNumber('atp')})`"
        boxtype="checkbox"
      />
      <customInput
        v-if="showTerms"
        style="border: 1px solid grey"
        v-model="modelValue.acceptTerms"
        type="yesno2"
        :label="`Ik ga akkoord met de algemene voorwaarden en overeenkomsten van ${
          $parent.intakeAdmin.beleggen.brand
        } (${termNumber('term')})`"
        boxtype="checkbox"
      />

      <div
        v-if="!$parent.redo
          && ($parent.intakeAdmin.beleggen.brand === 'VMVB'
            || $parent.intakeAdmin.beleggen.brand === 'BVS')
          && $parent.intakeAdmin.intakeCheck
        "
        class="card inset"
      >
        <b>Controle VMVB/BVS-intake</b><br />
        Intake controle aangevraagd door {{ $parent.intakeAdmin.intakeCheck.handedUser }} op
        {{ localDate($parent.intakeAdmin.intakeCheck.handedDate) }} <br />
        <template v-if="$parent.intakeAdmin.intakeCheck.checkedUser">
          Intake controle goedgekeurd door {{ $parent.intakeAdmin.intakeCheck.checkedUser }} op
          {{ localDate($parent.intakeAdmin.intakeCheck.checkedDate) }} <br />
        </template>
      </div>

      <div v-if="$parent.redo" class="msg">
        <b>Belangrijk</b><br />
        Met het opslaan en versturen van uw gegevens bevestigt u tevens dat
        uw klantprofiel de meest actuele informatie bevat.
        Verstuurde wijzigingen worden gecontroleerd en verwerkt in uw beleggingsplan.
        U ontvangt hier van een bericht in uw online berichten box.
      </div>
      <div
        v-if="errors == 0 && !checkDeceased && !invalidCollect && !invalidTerms && !invalidAtp"
        class="msg valid icon"
      >
        <div class="icon">
          <awesomeIcon icon="check"/>
        </div>
        Na het klikken op de knop ‘Rekening aanvragen’ gaan wij aan de slag met uw beleggingsplan.
        Hierin vindt u o.a. informatie over uw risicoprofiel en een toelichting op de samenstelling
        van uw portefeuille. Daarnaast zullen wij voor u vast een rekeningnummer aanvragen.
      </div>
      <div class="intake-buttons" style="display: flex; flex-direction: row-reverse;">
        <button
          v-if="($parent.intakeAdmin.beleggen.brand !== 'VMVB'
              && $parent.intakeAdmin.beleggen.brand !== 'BVS')
            || (
              ($parent.intakeAdmin.beleggen.brand === 'VMVB'
                || $parent.intakeAdmin.beleggen.brand === 'BVS')
              && !$parent.intakeAdmin.intakeCheck
            )
            || (
              ($parent.intakeAdmin.beleggen.brand === 'VMVB'
                || $parent.intakeAdmin.beleggen.brand === 'BVS')
              && $parent.intakeAdmin.intakeCheck
              && Number($store.state.role) > 9
            )
          "
          :class="[
            errors == 0 && !checkDeceased && !invalidCollect && !invalidTerms && !invalidAtp
              ? ''
              : 'disabled'
          ]"
          @click="checkSendIntake()"
        >
          <template
            v-if="
              !$parent.redo
              && ($parent.intakeAdmin.beleggen.brand === 'VMVB'
                || $parent.intakeAdmin.beleggen.brand === 'BVS')
            "
          >
            {{!$parent.intakeAdmin.intakeCheck ? 'Controle aanvragen' : 'Rekening aanvragen'}}
          </template>
          <template v-else-if="!$parent.redo">Rekening aanvragen</template>
          <template v-else>Versturen</template>
          <awesomeIcon icon="chevron-right" />
        </button>
        <button
          v-if="$parent.redo"
          @click="$parent.storeIntake($parent.step === 5 ? 2 : $parent.step, '0', true);"
        >
          Opslaan
          <awesomeIcon icon="save" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { filter, sumBy, some } from 'lodash-es';
import scorewidget from '../ui/scoreMeter';
import check from '../ui/valueChecker';

export default {
  name: 'IntakeOverviewPage',
  emits: ['update:model-value'],
  components: {
    scorewidget,
    check,
  },
  data() {
    return {
      score: 0,
      hash: null,
      resetemail: null,
      msg: '',
      firstPassword: false,
      showPassword: false,
    };
  },
  created() {
    if (this.getQueryVariable('hash')) {
      this.hash = this.getQueryVariable('hash');
      this.resetemail = this.getQueryVariable('email');
      this.$parent.sdk.checkReset(
        this.resetemail,
        this.hash,
        (response) => {
          if (response.status === 200) {
            this.msg = 'Uw wachtwoord dient te bestaan uit ten minste 12 karakters. Tip: gebruik een zin die u makkelijk onthoudt of een wachtwoord generator.';
            this.showPassword = true;
            this.firstPassword = true;
          }
        },
      );
    }
  },
  props: {
    modelValue: Object,
  },
  computed: {
    goalType() {
      if (
        (
          this.modelValue.goalData.type === 'levensonderhoud'
          && this.modelValue.goalData.box === '1'
        )
        || this.modelValue.goalData.type === 'netto-lijfrente-uitkerend'
        || this.modelValue.goalData.type === 'gouden-handdruk-uitkerend'
      ) {
        return 'uitkerend';
      }
      return 'opbouwend';
    },
    invalidCollect() {
      return this.showCollect && this.modelValue.acceptCollectTerms !== 'Yes';
    },
    showCollect() {
      if (
        this.modelValue.goalData.collect === 'Yes'
        && this.$parent.previousIntake.goalData.collect !== 'Yes'
      ) {
        return true;
      }
      return false;
    },
    invalidTerms() {
      return this.showTerms && this.modelValue.acceptTerms !== 'Yes';
    },
    showTerms() {
      return !this.$parent.redo;
    },
    invalidAtp() {
      return this.showAtp && this.modelValue.acceptAtpTerms !== 'Yes';
    },
    showAtp() {
      if (
        !this.$parent.redo
        && this.modelValue.atpData
        && this.modelValue.atpData.connected
        && this.modelValue.atpData.kosten === 'Yes'
      ) {
        return true;
      }
      return false;
    },
    checkDeceased() {
      if (
        this.modelValue.persoonsData.length > 1
        && this.filter(this.modelValue.persoonsData, this.$parent.deathFilter).length === 0
      ) {
        // all persons passed away
        return true;
      }
      return false;
    },
    pastPeriodChoice() {
      let text = '';
      if (this.modelValue.goalData.pastPeriodExperience === 'A') {
        text = 'U voelt zich comfortabel bij de waardeschommelingen binnen uw portefeuille.';
      } else if (this.modelValue.goalData.pastPeriodExperience === 'B') {
        text = `U maakt zich zorgen over de waardeschommelingen binnen uw portefeuille, maar begrijpt
        dat het past binnen uw profiel en wilt zo doorbeleggen.`;
      } else {
        text = `U maakt zich zorgen over de waardeschommelingen binnen uw portefeuille en wilt uw
        risicobereidheid aanpassen.`;
      }
      return text;
    },
    experienceInput() {
      const experienceInputArray = [];
      if (this.modelValue.experienceData.ervaringVermogensbeheer === 'Yes') {
        experienceInputArray.push('vermogensbeheer');
      }
      if (this.modelValue.experienceData.ervaringBeleggingsadvies === 'Yes') {
        experienceInputArray.push('beleggingsadvies');
      }
      if (this.modelValue.experienceData.ervaringOrderexecutie === 'Yes') {
        experienceInputArray.push('orderexecutie');
      }
      return experienceInputArray.join(', ');
    },
    offerSelected() {
      if (this.modelValue.goalData.type === 'netto-lijfrente-uitkerend') {
        return this.filter(
          this.modelValue.offers,
          (o) => (o.offerType === '4' || o.offerType === '5') && o.selected,
        )[0];
      }
      if (this.modelValue.goalData.type === 'gouden-handdruk-uitkerend') {
        return this.filter(
          this.modelValue.offers,
          (o) => (o.offerType === '2' || o.offerType === '3') && o.selected,
        )[0];
      }
      return this.filter(
        this.modelValue.offers,
        (o) => (o.offerType === '0' || o.offerType === '1') && o.selected,
      )[0];
    },
    typeToGoal() {
      if (this.modelValue.goalData.type === 'studiekinderen') {
        return 'studie kinderen';
      }
      if (this.modelValue.goalData.type === 'groteaankoop') {
        return 'grote aankoop';
      }
      if (this.modelValue.goalData.type === 'gouden-handdruk-opbouwend') {
        return 'gouden handdruk (opbouwend)';
      }
      if (this.modelValue.goalData.type === 'gouden-handdruk-uitkerend') {
        return 'gouden handdruk (uitkerend)';
      }
      if (this.modelValue.goalData.type === 'netto-lijfrente-uitkerend') {
        return 'netto lijfrente (uitkerend)';
      }
      if (this.modelValue.goalData.type === 'netto-lijfrente-opbouwend') {
        return 'netto lijfrente (opbouwend)';
      }
      if (
        this.modelValue.goalData.type === 'pensioen'
        && this.modelValue.goalData.box === '1'
      ) {
        return 'pensioen (box 1)';
      }
      if (
        this.modelValue.goalData.type === 'levensonderhoud'
        && this.modelValue.goalData.box === '1'
      ) {
        return 'leefrente (box 1)';
      }
      return this.modelValue.goalData.type;
    },
    paymentTerms() {
      if (this.modelValue.goalData.stortingenInterval === 'Per maand') {
        return 12;
      }
      if (this.modelValue.goalData.stortingenInterval === 'Per kwartaal') {
        return 4;
      }
      if (this.modelValue.goalData.stortingenInterval === 'Per halfjaar') {
        return 2;
      }
      return 1;
    },
    errors() {
      return this.filter(
        Object.values(this.$store.state.overview),
        (object) => !object,
      ).length;
    },
    value() {
      return this.modelValue;
    },
    files() {
      return this.$parent.files;
    },
  },
  methods: {
    filter,
    sumBy,
    termNumber(type) {
      if (type === 'term') {
        if (this.showCollect && this.showAtp) {
          return 3;
        }
        if (this.showCollect || this.showAtp) {
          return 2;
        }
      }
      if (type === 'atp') {
        if (this.showCollect) {
          return 2;
        }
      }
      return 1;
    },
    checkSendIntake() {
      if (Number(this.errors) === 0 && Number(this.$parent.role) >= 0) {
        if (this.checkDeceased) {
          this.$store.state.confirm.toggle({
            text: 'Er is iets misgegaan',
            title: 'Aanvraag mislukt',
            alert: true,
            confirmText: 'Terug',
            cb: () => {},
          });
        } else if (this.invalidCollect || this.invalidAtp || this.invalidTerms) {
          // Not all terms are selected
        } else {
          this.$parent.sendIntake();
        }
      } else {
        this.showPassword = !this.showPassword;
      }
    },
    localDate(date) {
      if (date) {
        return (new Date(date)).toLocaleString();
      }
      return null;
    },
    checkIbanSame() {
      return some(this.modelValue.transferData.overdrachten, (overdracht) => ['bv', 'psk2'].includes(overdracht.overdrachtType)
        && overdracht.iban === this.modelValue.rekeningData.iban
        && overdracht.kapitaalType !== 'Stakingswinst'
        && Number(overdracht.bedrag) > 0);
    },
    regex() {
      return /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/g;
    },
    sustainableAnswers(question) {
      let answer = '';
      if (question === 'sustainabilityNew') {
        if (this.modelValue.rekeningData.sustainabilityNew === 'Nee') {
          answer = 'U geeft aan geen duurzaamheidsvoorkeuren te hebben.';
        } else if (this.modelValue.rekeningData.sustainabilityNew === 'Ja, niet specifiek') {
          answer = 'U geeft aan duurzaamheidsvoorkeuren te hebben, maar geen specifieke voorkeuren.';
        } else {
          answer = 'U geeft aan specifieke duurzaamheidsvoorkeuren te hebben.';
        }
      } else if (question === 'sustainabilityEcologicPreference') {
        if (this.modelValue.rekeningData.sustainabilityEcologicPreference === 'Nee') {
          answer = 'U geeft aan geen voorkeur voor ecologisch- en/of duurzame beleggingen te hebben.';
        } else if (this.modelValue.rekeningData.sustainabilityEcologicPreference === 'Ja, ecologisch duurzame beleggingen') {
          answer = 'U geeft aan een voorkeur voor ecologisch duurzame beleggingen te hebben.';
        } else if (this.modelValue.rekeningData.sustainabilityEcologicPreference === 'Ja, duurzame beleggingen') {
          answer = 'U geeft aan een voorkeur voor duurzame beleggingen te hebben.';
        } else {
          answer = 'U geeft aan een voorkeur voor zowel ecologische duurzame beleggingen als duurzame beleggingen te hebben.';
        }
      } else if (question === 'sustainabilityEffect') {
        if (this.modelValue.rekeningData.sustainabilityEffect === 'Nee') {
          answer = 'U geeft aan dat wij geen rekening moeten houden met negatieve effecten op duurzaamheidsfactoren.';
        } else if (this.modelValue.rekeningData.sustainabilityEffect === 'Ja, geen PAI') {
          answer = 'U geeft aan dat wij rekening moeten houden met negatieve effecten op duurzaamheidsfactoren, maar niet volgens de PAI indicator/methode.';
        } else {
          answer = 'U geeft aan dat wij geen rekening moeten houden met negatieve effecten op duurzaamheidsfactoren volgens de PAI indicator/methode.';
        }
      } else if (question === 'sustainabilityPaiEnvironment') {
        answer = `
          U geeft aan
          ${this.modelValue.rekeningData.sustainabilityPaiEnvironment === 'Yes' ? '' : 'geen'}
          PAI toe te willen passen op het gebied van milieu (E).
        `;
      } else if (question === 'sustainabilityPaiSocial') {
        answer = `
          U geeft aan
          ${this.modelValue.rekeningData.sustainabilityPaiSocial === 'Yes' ? '' : 'geen'}
          PAI toe te willen passen op het gebied van maatschappij (S).
        `;
      } else if (question === 'sustainabilityPaiManagement') {
        answer = `
          U geeft aan
          ${this.modelValue.rekeningData.sustainabilityPaiManagement === 'Yes' ? '' : 'geen'}
          PAI toe te willen passen op het gebied van ondernemingsbestuur (G).
        `;
      } else if (question === 'sustainabilityPaiConsider') {
        if (this.modelValue.rekeningData.sustainabilityPaiConsider === 'Geen') {
          answer = 'U geeft aan de PAI duurzaamheidsvoorkeuren zowel kwalitatief als kwantitatief niet mee te laten wegen.';
        } else if (this.modelValue.rekeningData.sustainabilityPaiConsider === 'Kwalitatief') {
          answer = 'U geeft aan de PAI duurzaamheidsvoorkeuren kwalitatief mee te laten wegen.';
        } else if (this.modelValue.rekeningData.sustainabilityPaiConsider === 'Kwantitatief') {
          answer = 'U geeft aan de PAI duurzaamheidsvoorkeuren kwantitatief mee te laten wegen.';
        } else {
          answer = 'U geeft aan de PAI duurzaamheidsvoorkeuren zowel kwalitatief als  kwantitatief mee te laten wegen.';
        }
      }
      return answer;
    },
    resetPassword() {
      if (this.$refs.newpassword.value !== this.$refs.newpassword2.value) {
        this.msg = 'Nieuwe wachtwoorden komen niet overeen';
      } else if (this.$refs.newpassword.value.length < 12) {
        this.msg = 'Uw wachtwoord is niet lang genoeg (minimaal 12 karakters)';
      } else {
        this.$parent.sdk.doReset(
          this.resetemail,
          this.hash,
          this.$refs.newpassword.value,
          () => {
            this.$parent.storeIntake(this.modelValue.step, null, false, true);
          },
        );
      }
    },
    futureMonthName(startDate, i) {
      const date = new Date();
      date.setMonth(new Date(startDate).getMonth() + i);
      // date.setDate(1);
      return new Date(date).toLocaleString('nl-NL', { year: 'numeric', month: 'long' });
    },
    readableTransferName(name) {
      let readableName;
      if (name === 'bv') {
        readableName = 'vanuit een bedrijf';
      }
      if (name === 'psk') {
        readableName = 'vanuit PSK';
      }
      if (name === 'psk2') {
        readableName = 'vanuit overige';
      }
      if (name === 'intern') {
        readableName = 'interne overboeking';
      }
      return readableName;
    },
    docLink() {
      if (this.$parent.intakeAdmin.beleggen.brand === 'OXBY') {
        return 'https://oxby.nl/documentencentrum/';
      }
      if (this.$parent.intakeAdmin.beleggen.brand === 'Doelbeleggen') {
        return 'https://www.doelbeleggen.nl/documentencentrum/';
      }
      return false;
    },
    financeFilter(o) {
      return this.$parent.financeFilter(o);
    },
    deathFilter(o) {
      return this.$parent.deathFilter(o);
    },
    filesFilter(prefix) {
      return filter(
        this.$parent.files,
        (o) => o.path.indexOf(prefix) > -1,
      ).length;
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: $color-highlight;
}
.invalid {
  color: #f00;
}
ul.iconlist {
  list-style-type: none;
  padding: 20px;
  margin: 0;
  li {
    padding: 5px;
    position: relative;
    padding-left: 30px;
    svg {
      position: absolute;
      left: 2px;
      top: 7px;
      color: $color-highlight;
    }
  }
}
#overview {
  .alertButton {
    float: right;
    @media #{$mobile} {
      margin-top: 10px;
    }
  }
  .card,
  .msg {
    margin-top: 10px;
    line-height: 1.5em;
  }
  b {
    font-size: 16px;
  }
  .edit {
    cursor: pointer;
    &:hover {
      background-color: rgba($color-highlight, 0.2);
    }
    b {
      position: relative;
    }
    .fa-icon {
      position: absolute;
      top: 1px;
      right: -18px;
      color: rgba(0,0,0,0.2);
      font-weight: normal;
    }
  }
  ol {
    padding-left: 13px;
    li {
      margin-top: 5px;
      &:first-child {
        margin-top: 0;
      }
    }
  }
}
.footer {
  background-color: $color-highlight;
  color: $color-buttonbacktext1;
  margin-top: 10px;
  border-radius: $br;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  button {
    font-weight: 600;
    svg {
      margin-left: 5px;
      padding-bottom:1px;
    }
    &:hover {
      background-color: darken($color-highlight, 2%);
    }
    &.disabled {
      cursor: not-allowed;
    }
  }
}
@media #{$mobile} {
  #overview {
    padding: 10px;
    padding-top: 35px;
  }
  .menubar {
    left: 0;
    right: 0;
  }
}

</style>
